/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _base = __webpack_require__(12);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _header = __webpack_require__(25);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _TopVideoPlayer = __webpack_require__(73);
	
	var _TopVideoPlayer2 = _interopRequireDefault(_TopVideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _TopVideoPlayer2.default();

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ScriptLoader = __webpack_require__(3);
	
	var _ScriptLoader2 = _interopRequireDefault(_ScriptLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Analytics = function () {
	    function Analytics() {
	        _classCallCheck(this, Analytics);
	
	        this.isUtagLoaded = false;
	        this.metaObj = this.getPageMeta();
	        this.refreshRate = this.metaObj ? this.metaObj.refresh_rate : 0;
	        this.reSendMetadata();
	    }
	
	    _createClass(Analytics, [{
	        key: 'getUtagLib',
	        value: function getUtagLib(url, callback) {
	
	            var scriptLoader = new _ScriptLoader2.default();
	            scriptLoader.getScript(url, callback, true);
	        }
	    }, {
	        key: 'loadUtagLib',
	        value: function loadUtagLib(url) {
	            var _this = this;
	
	            if (!this.isUtagLoaded) {
	                this.getUtagLib(url, function () {
	                    _this.isUtagLoaded = true;
	                });
	            }
	        }
	
	        // on page load
	
	    }, {
	        key: 'sendPageView',
	        value: function sendPageView(data) {
	            //get page metadata if nothing is passed
	            var data = data || this.getPageMeta();
	            this.loadUtagLib(data.utaglib_path);
	            window.utag_data = data;
	        }
	    }, {
	        key: 'getPageMeta',
	        value: function getPageMeta() {
	
	            var data = {};
	            var metaEl = document.querySelector('[fs-prop="analytics"]');
	            var attributes = ['account', 'cms-id', 'utaglib-path', 'utags', 'page-name', 'category', 'sub-category', 'page-type', 'page_topic', 'page-type-alias,', 'page-topic', 'user-state', 'filename', 'story-title', 'gallery-name', 'source', 'author', 'publish-date', 'refresh-rate', 'story-position', 'hasEmbeddedGallery', 'site-name', 'page-attribute'];
	
	            for (var i = 0, l = attributes.length; i < l; i++) {
	                var attr = attributes[i];
	                var val = metaEl.getAttribute(attr);
	                if (val != null) {
	                    attr = attr.indexOf('-') >= 0 ? attr.replace(/-/g, '_') : attr;
	                    data[attr] = val.trim();
	                }
	            }
	            return data;
	        }
	    }, {
	        key: 'reSendMetadata',
	        value: function reSendMetadata() {
	            if (this.refreshRate > 0) {
	                setInterval(function () {
	                    var data = window.utag_data;
	                    if (data !== null || data !== undefined) {
	                        this.utagView(window.utag_data);
	                    }
	                }.bind(this), this.refreshRate * 1000);
	            }
	        }
	
	        //utag api - call for any subsequent utag views
	
	    }, {
	        key: 'utagView',
	        value: function utagView(data) {
	
	            this.loadUtagLib(window.utag_data.utaglib_path);
	            /* current data format (dont remove this yet)
	            {
	             "account": "foxsports",
	             "page_name": "fscom:home:home",
	             "utags": "home|west|mlb",
	             "category": "home",
	             "page_type": "home",
	             "cms_id": "12121",
	             "page_topic": "classes:fsdigital/fscom/Home,classes:fsdigital/fscom/local/west/top-headlines,classes:fsdigital/fscom/local/west,internal:components/buzzer/mlb",
	             "filename": "http://www.foxsports.com/home",
	             "user_state": "", 
	             "analyticsRefreshRate": "0"
	            }
	            */
	
	            try {
	                if (typeof utag !== 'undefined') {
	                    utag.view(data);
	                }
	            } catch (e) {
	                console.log(e);
	                throw new Error("ANALYTICS !! - something went wrong calling utag.view");
	            }
	        }
	
	        //event and link tracking
	
	    }, {
	        key: 'utagLink',
	        value: function utagLink(data) {
	            data.test = "fb-click";
	
	            try {
	                utag.link(data);
	            } catch (e) {
	                throw new Error("ANALYTICS !! - something went wrong calling utag.link");
	            }
	        }
	    }, {
	        key: 'sendEventView',
	        value: function sendEventView(data) {
	            this.utagLink(data);
	        }
	    }]);
	
	    return Analytics;
	}();
	
	exports.default = new Analytics();

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScriptLoader = function () {
		function ScriptLoader() {
			_classCallCheck(this, ScriptLoader);
	
			this.elPassingTopPos = false;
		}
	
		//get browser base url
	
	
		_createClass(ScriptLoader, [{
			key: 'getBaseurl',
			value: function getBaseurl() {
				var loc = location;
				return loc.origin || loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '');
			}
	
			/**
	   * @desc inject scripts into DOM dynamically with sync or async and execute a callback after script is loaded
	   * @param string url
	   * @param function callback
	   * @param bool async - true or false
	   * @return undefined
	   */
	
		}, {
			key: 'getScript',
			value: function getScript(url, callback, async) {
	
				// Create a new script and setup the basics.
				var script = document.createElement("script");
				var firstScript = document.getElementsByTagName('script')[0];
	
				//if the third argument is passed, load the script asynchronously; otherwise load it synchronously
				if (async === undefined && async !== false) {
					script.async = true;
				} else {
					script.async = false;
				}
	
				script.src = url;
				// Handle the case where an optional callback was passed in.
				if ("function" === typeof callback) {
					script.onload = function () {
	
						callback();
						// Clear it out to avoid getting called more than once or any memory leaks.
						script.onload = script.onreadystatechange = undefined;
					};
	
					script.onreadystatechange = function () {
						if ("loaded" === script.readyState || "complete" === script.readyState) {
							script.onload();
						}
					};
				}
	
				//Attach the script tag to the page (before the first script) so the magic can happen.
				return firstScript.parentNode.insertBefore(script, firstScript);
			}
		}]);
	
		return ScriptLoader;
	}();
	
	exports.default = ScriptLoader;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(5);

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	// Production steps of ECMA-262, Edition 6, 22.1.2.1
	if (!Array.from) {
	  Array.from = function () {
	    var toStr = Object.prototype.toString;
	    var isCallable = function isCallable(fn) {
	      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
	    };
	    var toInteger = function toInteger(value) {
	      var number = Number(value);
	      if (isNaN(number)) {
	        return 0;
	      }
	      if (number === 0 || !isFinite(number)) {
	        return number;
	      }
	      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
	    };
	    var maxSafeInteger = Math.pow(2, 53) - 1;
	    var toLength = function toLength(value) {
	      var len = toInteger(value);
	      return Math.min(Math.max(len, 0), maxSafeInteger);
	    };
	
	    // The length property of the from method is 1.
	    return function from(arrayLike /*, mapFn, thisArg */) {
	      // 1. Let C be the this value.
	      var C = this;
	
	      // 2. Let items be ToObject(arrayLike).
	      var items = Object(arrayLike);
	
	      // 3. ReturnIfAbrupt(items).
	      if (arrayLike == null) {
	        throw new TypeError("Array.from requires an array-like object - not null or undefined");
	      }
	
	      // 4. If mapfn is undefined, then let mapping be false.
	      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
	      var T;
	      if (typeof mapFn !== 'undefined') {
	        // 5. else
	        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
	        if (!isCallable(mapFn)) {
	          throw new TypeError('Array.from: when provided, the second argument must be a function');
	        }
	
	        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
	        if (arguments.length > 2) {
	          T = arguments[2];
	        }
	      }
	
	      // 10. Let lenValue be Get(items, "length").
	      // 11. Let len be ToLength(lenValue).
	      var len = toLength(items.length);
	
	      // 13. If IsConstructor(C) is true, then
	      // 13. a. Let A be the result of calling the [[Construct]] internal method 
	      // of C with an argument list containing the single item len.
	      // 14. a. Else, Let A be ArrayCreate(len).
	      var A = isCallable(C) ? Object(new C(len)) : new Array(len);
	
	      // 16. Let k be 0.
	      var k = 0;
	      // 17. Repeat, while k < len… (also steps a - h)
	      var kValue;
	      while (k < len) {
	        kValue = items[k];
	        if (mapFn) {
	          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
	        } else {
	          A[k] = kValue;
	        }
	        k += 1;
	      }
	      // 18. Let putStatus be Put(A, "length", len, true).
	      A.length = len;
	      // 20. Return A.
	      return A;
	    };
	  }();
	}

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	__webpack_require__(4);
	
	var _pageSkinPin = __webpack_require__(13);
	
	var _pageSkinPin2 = _interopRequireDefault(_pageSkinPin);
	
	var _Ads = __webpack_require__(16);
	
	var _Ads2 = _interopRequireDefault(_Ads);
	
	var _BannerAdsPin = __webpack_require__(18);
	
	var _BannerAdsPin2 = _interopRequireDefault(_BannerAdsPin);
	
	var _skinAdsPin = __webpack_require__(19);
	
	var _skinAdsPin2 = _interopRequireDefault(_skinAdsPin);
	
	var _Analytics = __webpack_require__(2);
	
	var _Analytics2 = _interopRequireDefault(_Analytics);
	
	var _scorestrip = __webpack_require__(20);
	
	var _scorestrip2 = _interopRequireDefault(_scorestrip);
	
	var _sidebar = __webpack_require__(22);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _promo = __webpack_require__(23);
	
	var _promo2 = _interopRequireDefault(_promo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ads = new _Ads2.default();
	ads.enableRenderOnScroll();
	ads.renderPageAds();
	
	// Set up sidebar components
	new _sidebar2.default();
	
	//temporary for external access
	//being used in big-board.js and marquee gallery
	window.FsAds = ads;
	
	_Analytics2.default.sendPageView();
	
	if (document.querySelector('wis-scorestrip')) {
		new _scorestrip2.default().init();
	}
	
	//object can be reused when importing this script
	exports.default = {
		'ads': ads,
		'analytics': _Analytics2.default
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _scrollEvent = __webpack_require__(14);
	
	var _scrollEvent2 = _interopRequireDefault(_scrollEvent);
	
	var _Viewports = __webpack_require__(15);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	    "PageSkinPin"
	    Purpose:
	        to enable creative/page background skin pinning when scrolling 
	        for WP posts and pages that has the "Page Skin" meta box.
	    NOTE:
	        * "Page Skin" is different from skin ads, as the former is added from the WP Admin, 
	        while the latter is driven by the ad engine.
	        * this class has to be very light.
	*/
	
	var PageSkinPin = function () {
	    function PageSkinPin() {
	        _classCallCheck(this, PageSkinPin);
	
	        // elements and classnames
	        this.bodyClassList = document.body.classList;
	        this.bodyHeader = document.getElementById('js-body-header');
	        this.secNav = document.querySelector('.section-nav');
	        // objects and values
	        this.viewports = new _Viewports2.default();
	        this.lastScrollTop = 0;
	        this.hasSkin = this.hasPageSkin();
	
	        if (this.hasSkin) {
	            // add scroll event only when page skin is detected
	            var toggleScrollEvent = _scrollEvent2.default.throttle(this.togglePageSkinPosOnScroll.bind(this), 10);
	
	            window.addEventListener("scroll", toggleScrollEvent);
	
	            this.togglePageSkinPosOnScroll();
	        }
	    }
	    // get pin position based on the global and secondary navigation's structure
	
	
	    _createClass(PageSkinPin, [{
	        key: 'getPinPosition',
	        value: function getPinPosition() {
	            // check for secondary nav
	            if (this.secNav) {
	                // check for secondary nav type
	                if (this.bodyClassList.contains('contains-team-display-menu') || this.bodyClassList.contains('secondary-tall')) {
	                    return this.bodyHeader.offsetHeight + this.secNav.offsetHeight;
	                } else {
	                    return this.secNav.offsetHeight;
	                }
	            }
	            // if there's no secondary nav (homepage, etc.)
	            return 0;
	        }
	        // check for the page skin classname added by a PHP function
	
	    }, {
	        key: 'hasPageSkin',
	        value: function hasPageSkin() {
	            return this.bodyClassList.contains('has-skin');
	        }
	        // toggle page skin pinning condition
	
	    }, {
	        key: 'togglePageSkinPosOnScroll',
	        value: function togglePageSkinPosOnScroll() {
	
	            if (this.viewports.getViewPort() === 'desktop') {
	                // get scroll position
	                var scrollYpos = window.pageYOffset || document.documentElement.scrollTop;
	                if (this.hasSkin) {
	                    // get pin position
	                    this.pinPos = this.pinPos || this.getPinPosition();
	
	                    if (scrollYpos >= this.pinPos) {
	                        // pin when scroll position is beyond the pin position
	                        this.bodyClassList.add('pageSkinPin');
	                    } else if (scrollYpos < this.pinPos) {
	                        // remove when scroll position is before the pin position
	                        this.bodyClassList.remove('pageSkinPin');
	                    }
	                }
	
	                this.lastScrollTop = scrollYpos;
	            }
	        }
	    }]);
	
	    return PageSkinPin;
	}();
	// instantiate on import/page load
	
	
	exports.default = new PageSkinPin();

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var scrollEvent = function () {
	    function scrollEvent() {
	        _classCallCheck(this, scrollEvent);
	    }
	    // this is working in progress scrollEvent class.
	    // We will add more scroll events in the file
	    // that can be shared across the whole site.
	
	
	    //throttle scrolling event to improve performance
	
	
	    _createClass(scrollEvent, [{
	        key: "throttle",
	        value: function throttle(callback, wait) {
	            var time,
	                go = true;
	            return function () {
	                if (go) {
	                    go = false;
	                    time = setTimeout(function () {
	                        time = null;
	                        go = true;
	                        callback.call();
	                    }, wait);
	                }
	            };
	        }
	
	        //debounce scrolling event to improve performance
	
	    }, {
	        key: "debounce",
	        value: function debounce(callback, delay) {
	            var timeout = null;
	            return function () {
	                if (timeout) {
	                    clearTimeout(timeout);
	                }
	                var args = arguments;
	                timeout = setTimeout(function () {
	                    callback.apply(null, args);
	                    timeout = null;
	                }, delay);
	            };
	        }
	    }]);
	
	    return scrollEvent;
	}();
	
	;
	
	exports.default = new scrollEvent();

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Viewports = function () {
	    function Viewports() {
	        var _this = this;
	
	        var viewports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'mobile': 767, 'tablet': 768, 'desktop': 1024 };
	
	        _classCallCheck(this, Viewports);
	
	        this.winW = window.innerWidth;
	        this.winH = window.innerHeight;
	        this.docW = document.body.clientWidth;
	        this.isIPad = navigator.userAgent.match(/iPad/i);
	        this.isMobile = navigator.userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i);
	        this.isTouch = navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
	        this.viewPorts = viewports;
	
	        window.addEventListener("resize", function () {
	            _this.setWinW(window.innerWidth);
	            _this.setWinH(window.innerHeight);
	            _this.setDocW(document.body.clientWidth);
	        });
	    }
	
	    //setter for window inner width
	
	
	    _createClass(Viewports, [{
	        key: 'setWinW',
	        value: function setWinW(w) {
	            this.winW = w;
	        }
	
	        //getter for window inner width
	
	    }, {
	        key: 'getWinW',
	        value: function getWinW() {
	            return this.winW;
	        }
	
	        //setter for document body clientWidth
	
	    }, {
	        key: 'setDocW',
	        value: function setDocW(w) {
	            this.docW = w;
	        }
	
	        //getter for document body clientWidth
	
	    }, {
	        key: 'getDocW',
	        value: function getDocW() {
	            return this.docW;
	        }
	
	        //setter for winH
	
	    }, {
	        key: 'setWinH',
	        value: function setWinH(h) {
	            this.winH = h;
	        }
	
	        //getter for winH
	
	    }, {
	        key: 'getWinH',
	        value: function getWinH() {
	            return this.winH;
	        }
	    }, {
	        key: 'getViewPort',
	        value: function getViewPort() {
	
	            var winW = this.winW;
	
	            return winW <= this.viewPorts.mobile ? 'mobile' : winW >= this.viewPorts.desktop ? 'desktop' : 'tablet';
	        }
	
	        /**
	         * @desc checking element is in view. This function works well to determine if the element is in view,
	         * but it takes a little time to do the calculation to get top, bottom, left and right positions
	         * @param object el
	         * @return bool - true or false
	         */
	
	    }, {
	        key: 'isElmInViewport',
	        value: function isElmInViewport(el) {
	
	            var rect = el.getBoundingClientRect();
	
	            return rect && rect.top >= 0 && rect.left >= 0 && rect.bottom <= this.winH && rect.right <= this.winW;
	        }
	
	        /**
	         * @desc checking element top postion is passing . This function works faster than the above isElmInViewport ,
	         * since we only need to check elment top position. This should be good to use if we just want to check the scroll
	         * position and doing pinning or lazyloading the scripts
	         * @param dom object el
	         * @param Number offet: passing an offet here if we want the scroll event rendered a bit early
	         * @return bool - true or false
	         */
	
	    }, {
	        key: 'isElmTopPosPassing',
	        value: function isElmTopPosPassing(el, offet) {
	
	            var rect = el.getBoundingClientRect();
	            var checkPos = undefined;
	
	            if (offet !== undefined && !isNaN(offet)) {
	                checkPos = rect.top - offet;
	            } else {
	                checkPos = rect.top;
	            }
	
	            return checkPos <= this.winH;
	        }
	    }]);
	
	    return Viewports;
	}();
	
	exports.default = Viewports;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BannerAd2 = __webpack_require__(17);
	
	var _BannerAd3 = _interopRequireDefault(_BannerAd2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               usage:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               var ads = new FsAds();
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ads.renderPageAds();
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var Ads = function (_BannerAd) {
	    _inherits(Ads, _BannerAd);
	
	    //you can pass selector parent if you dont want to parse the entire page
	    function Ads(regionEl) {
	        _classCallCheck(this, Ads);
	
	        console.log("TGX Ads start");
	
	        var _this = _possibleConstructorReturn(this, (Ads.__proto__ || Object.getPrototypeOf(Ads)).call(this));
	
	        _this.adSelector = '.fsAdContainer:not([data-ad-isrendered])';
	
	        _this.collectionIds = [];
	        _this.adElements = [];
	        _this.elementsForScroll = [];
	        _this.adConfigs = [];
	
	        _this.pageMeta = undefined;
	        _this.refreshTimer = undefined;
	        //if there is a specific container to parse ads. needs to be selector format
	        _this.regionEl = regionEl || undefined;
	        _this.randomizeId = false;
	        _this.slotCount = 0;
	
	        _this.posAll = undefined;
	
	        _this.renderOnScroll = false;
	
	        _this.isLogEnabled = false;
	        _this.checkLogEnabled();
	
	        _this.filterAdSelector();
	        _this.enableBannerPinning();
	
	        _this.bottomOffset = 300;
	
	        _this.refreshQueue = [];
	
	        return _this;
	    }
	
	    //starter method
	
	
	    _createClass(Ads, [{
	        key: 'renderPageAds',
	        value: function renderPageAds(siteConfig) {
	
	            this.log("Ads - Render New Set");
	
	            //get page config
	            var pageMeta = siteConfig || this.getPageMeta();
	            this.setSiteMeta(pageMeta);
	
	            //check if on scroll is enabled
	            if (this.renderOnScroll) {
	                this.adElements = this.getAdElements();
	                this.setElementsInView(this.adElements);
	                this.startScroll();
	            } else {
	                this.adElements = this.getAdElements();
	                this.adConfigs = this.getAdConfigs(this.adElements);
	                this.createSlots(this.adConfigs);
	            }
	
	            return this;
	        }
	    }, {
	        key: 'log',
	        value: function log(message) {
	            this.isLogEnabled && console.log(message);
	        }
	    }, {
	        key: 'checkLogEnabled',
	        value: function checkLogEnabled() {
	            this.isLogEnabled = location.href.indexOf('adlog=true') > -1 ? true : false;
	        }
	    }, {
	        key: 'setPOSForAll',
	        value: function setPOSForAll(posAll) {
	            this.posAll = posAll;
	        }
	
	        //for gallery purpose
	
	    }, {
	        key: 'enableIdRandomizer',
	        value: function enableIdRandomizer() {
	            this.randomizeId = true;
	        }
	    }, {
	        key: 'enableRenderOnScroll',
	        value: function enableRenderOnScroll() {
	            this.renderOnScroll = true;
	        }
	    }, {
	        key: 'setElementsInView',
	        value: function setElementsInView(elements) {
	            var _this2 = this;
	
	            elements.map(function (el) {
	
	                //set lazyload attributes first
	                el.setAttribute('data-in-view', "false");
	                el.setAttribute('data-in-view-rendered', "false");
	
	                //dont lazy load if disable inview is set (render right away)
	                el.hasAttribute("data-disable-inview") ? _this2.renderSlotByEl(el) : _this2.elementsForScroll.push(el);
	            });
	        }
	    }, {
	        key: 'startScroll',
	        value: function startScroll() {
	
	            window.addEventListener('scroll', this.checkSlotsInView.bind(this));
	            //also call this for the first time
	            this.checkSlotsInView();
	        }
	    }, {
	        key: 'checkSlotsInView',
	        value: function checkSlotsInView() {
	            var _this3 = this;
	
	            this.elementsForScroll.map(function (el) {
	
	                //offset as default first
	                var offset = el.hasAttribute("data-inview-offset") ? el.dataset.inviewOffset : undefined;
	
	                //if element in view
	                if (_this3.isElementInView(el, offset) && _this3.isDisplayed(el)) {
	                    //check if in view is false first
	                    if (el.getAttribute('data-in-view') === "false") {
	                        //render slot first time in view
	                        if (el.getAttribute("data-in-view-rendered") === "false") {
	                            //create slot
	                            _this3.renderSlotByEl(el);
	                            el.setAttribute("data-in-view-rendered", "true");
	                            //refresh in view
	                        } else {
	                            //dont refresh in view when disable-inview-refresh is added
	                            !el.hasAttribute("data-disable-inview-refresh") ? _this3.refresh([el.id]) : undefined;
	                        }
	
	                        el.setAttribute('data-in-view', "true");
	                    }
	                    //if not in view
	                } else {
	
	                    if (el.getAttribute('data-in-view') === "true") {
	                        el.setAttribute('data-in-view', "false");
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'isElementInView',
	        value: function isElementInView(element, offset) {
	            //change to when it only shows partial
	            var rect = element.getBoundingClientRect();
	            var elemTop = rect.top;
	            var elemBottom = rect.bottom;
	            var viewportHeight = window.innerHeight;
	
	            if (offset) {
	                elemTop -= offset;
	                elemBottom += offset;
	            }
	
	            var isVisible = elemTop < viewportHeight && elemBottom >= 0;
	
	            return isVisible;
	        }
	
	        //https://davidwalsh.name/offsetheight-visibility
	        //for parent display check visible
	
	    }, {
	        key: 'isDisplayed',
	        value: function isDisplayed(element) {
	
	            var displayed = false;
	
	            displayed = element.offsetHeight !== 0 ? true : false;
	
	            return displayed;
	        }
	    }, {
	        key: 'getVisibleByPct',
	        value: function getVisibleByPct(el) {
	
	            var r = el.getBoundingClientRect(),
	                elH = r.height,
	                t = r.top,
	                b = r.bottom,
	                H = window.innerHeight;
	
	            var visArea = Math.max(0, t > 0 ? Math.min(elH, H - t) : b < H ? b : H);
	
	            var pctVisible = visArea / elH * 100;
	
	            return pctVisible;
	        }
	
	        //AEM getPageMeta. need to have a new one for WP
	
	    }, {
	        key: 'getPageMeta',
	        value: function getPageMeta() {
	
	            var adMeta = {};
	
	            try {
	                var meta = document.querySelector('[fs-prop="ads"]');
	
	                adMeta.dfpRootNode = meta.getAttribute("dfp-root-node");
	                adMeta.refreshRate = meta.getAttribute("refresh-rate");
	                adMeta.networkId = meta.getAttribute("network-id");
	                adMeta.pagePath = meta.getAttribute("page-path");
	                adMeta.isfwenabled = meta.getAttribute("isfwenabled");
	                adMeta.fw_pagepath = meta.getAttribute("fw_pagepath");
	                adMeta.pageTargeting = meta.getAttribute("page-targeting");
	                adMeta.pageTargeting = JSON.parse(adMeta.pageTargeting);
	            } catch (e) {
	                console.error("Ads - theres a problem with getting metadata! ", e);
	            }
	
	            window.fsadmeta = adMeta;
	
	            return adMeta;
	        }
	    }, {
	        key: 'setSiteMeta',
	        value: function setSiteMeta(pageMeta) {
	
	            this.pageMeta = pageMeta;
	
	            this.setTGXSiteConfig(this.pageMeta);
	
	            //adding this back as this is reading from ads meta
	            this.setPageRefresh(this.pageMeta.refreshRate);
	
	            return this;
	        }
	
	        //TIME library api
	
	    }, {
	        key: 'setTGXSiteConfig',
	        value: function setTGXSiteConfig(pageMeta) {
	
	            //remove fscom or fstest in path
	            pageMeta.pagePath = pageMeta.pagePath.replace('/fscom/', '');
	            pageMeta.pagePath = pageMeta.pagePath.replace('/fstest/', '');
	            pageMeta.pagePath = pageMeta.pagePath.replace('/FSCOM/', '');
	
	            //set page targeting
	            var pageTargeting = pageMeta["pageTargeting"] ? pageMeta.pageTargeting[0] : {};
	
	            var tgxSiteConfig = { // FOR DFP     
	                setTargeting: pageTargeting,
	                // additional targeting globally on the Slot Level     
	                setGlobalTargeting: {
	                    ch: 'home'
	                },
	                enableSingleRequest: false,
	                collapseEmptyDivs: false,
	                //rootnode test
	                sitename: pageMeta.dfpRootNode,
	                //page path
	                zone: pageMeta.pagePath
	            };
	
	            console.log("site config ", tgxSiteConfig);
	
	            //time library
	            time_dfp.push(function () {
	                time_dfp.init(tgxSiteConfig);
	            });
	        }
	    }, {
	        key: 'createTGXAdSlot',
	        value: function createTGXAdSlot(slotConfig) {
	
	            //check if pos is available, not set default value
	            slotConfig["pos"] = slotConfig["pos"] || "1";
	            //check if pos is forced for all slots
	            var pos = this.posAll ? this.posAll : slotConfig.pos;
	
	            var tgxSlot = {
	                id: slotConfig.id,
	                size: slotConfig.slotSizes,
	                targeting: {
	                    'param': 'value',
	                    'pos': pos,
	                    'location': 'TOP'
	                },
	                collapse: true
	            };
	
	            //check if responsive sizes is provided
	            if (slotConfig.responsiveSizes && slotConfig.responsiveSizes.length > 0) {
	                tgxSlot.sizes = slotConfig.responsiveSizes;
	            }
	
	            //conditional logging
	            this.log("Ads - slot Created for: " + tgxSlot.id + " size: " + tgxSlot.size.toString());
	            performance.mark("ADS_CREATE: ", tgxSlot.size.toString());
	
	            this.refreshQueue.push(tgxSlot.id);
	            time_dfp.push(function () {
	                time_dfp.defineSlot(tgxSlot);
	            });
	        }
	
	        //can accept array of slots or single slot
	
	    }, {
	        key: 'createSlots',
	        value: function createSlots(configs) {
	            var _this4 = this;
	
	            if (Array.isArray(configs)) {
	                configs.map(function (config) {
	                    _this4.createTGXAdSlot(config);
	                    _this4.collectionIds.push(config.id);
	                });
	            } else {
	                this.createTGXAdSlot(configs);
	                this.collectionIds.push(configs.id);
	            }
	        }
	    }, {
	        key: 'getDataConfig',
	        value: function getDataConfig(element) {
	
	            var data = {};
	
	            if (element && !(element == null)) {
	                data = JSON.parse(element.getAttribute("data-ad-options"));
	
	                window.lastel = element;
	                window.lastdata = data;
	            }
	
	            return data;
	        }
	    }, {
	        key: 'getRandomId',
	        value: function getRandomId() {
	
	            var rand = Math.floor(Math.random() * 50);
	
	            return 'fs-ad-rand-' + rand + this.slotCount;
	        }
	    }, {
	        key: 'renderSlotByEl',
	        value: function renderSlotByEl(el) {
	
	            var config = this.getConfigFromEl(el);
	
	            this.createSlots(config);
	
	            this.slotCount++;
	        }
	    }, {
	        key: 'getConfigFromEl',
	        value: function getConfigFromEl(el) {
	
	            var config = this.getDataConfig(el);
	
	            //process correct id's
	            //generate id if theres no id (bigboard pages)
	            config["id"] = config.id || this.getRandomId();
	            //set this slot as rendered
	            el.id = config.id;
	            //if randomizer is enabled(only used in gallery)
	            if (this.randomizeId) {
	                config.id = config.id + this.getRandomId();
	                el.id = config.id;
	            }
	
	            el.setAttribute('data-in-view', "false");
	            //el.style.height = "1px";
	            el.setAttribute('data-ad-isrendered', 'true');
	
	            this.slotCount++;
	
	            return config;
	        }
	    }, {
	        key: 'filterAdSelector',
	        value: function filterAdSelector() {
	            //for gallery page filtering
	            var desktopOnlySelector = '.fsAdContainer:not(.ad-for-devices):not([data-ad-isrendered])';
	
	            this.adSelector = window.innerWidth > 1024 ? desktopOnlySelector : this.adSelector;
	
	            return this.adSelector;
	        }
	    }, {
	        key: 'getAdSelector',
	        value: function getAdSelector() {
	
	            return this.adSelector;
	        }
	    }, {
	        key: 'getAdElements',
	        value: function getAdElements() {
	
	            var adContainer = this.getAdSelector();
	
	            //check if there is a region for parsing passed
	            adContainer = this.regionEl ? this.regionEl + ' ' + adContainer : adContainer;
	
	            var allAdElements = [].slice.call(document.querySelectorAll(adContainer));
	
	            //return all ad elements in the page and convert to array
	            return allAdElements;
	        }
	    }, {
	        key: 'getAdConfigs',
	        value: function getAdConfigs(adElements) {
	            var _this5 = this;
	
	            var configs = [];
	
	            [].slice.call(adElements).map(function (el) {
	
	                var config = _this5.getConfigFromEl(el);
	
	                configs.push(config);
	            });
	
	            return configs;
	        }
	    }, {
	        key: 'setPageRefresh',
	        value: function setPageRefresh(refreshRate) {
	
	            if (refreshRate > 0) {
	                //assign reference to local var for future disposal
	                this.refreshTimer = setInterval(function () {
	
	                    this.refreshAllInView();
	                }.bind(this), refreshRate * 1000);
	            }
	
	            return this;
	        }
	
	        //can accept array of slot ids ["id1","id2"]
	
	    }, {
	        key: 'refresh',
	        value: function refresh(slotIds) {
	            var _this6 = this;
	
	            var ids = slotIds || undefined;
	
	            //check if slot ids are passed
	            if (ids) {
	                //refresh if its not in refresh queue
	                var refreshItems = ids.filter(function (id) {
	                    if (_this6.refreshQueue.indexOf(id) < 0) {
	                        //store in the queue
	                        _this6.refreshQueue.push(id);
	                        return true;
	                    } else {
	                        return false;
	                    }
	                });
	
	                this.log("Ads - slot refresh " + refreshItems);
	
	                //only refresh when theres items
	                refreshItems.length > 0 && time_dfp.refresh(refreshItems);
	            } else {
	                time_dfp.refresh();
	            }
	        }
	
	        //only refresh elements that are in view
	
	    }, {
	        key: 'refreshAllInView',
	        value: function refreshAllInView() {
	            var _this7 = this;
	
	            this.log("Ads - slot refresh all in view ");
	
	            this.elementsForScroll.map(function (el) {
	
	                _this7.getVisibleByPct(el) > 50 && _this7.refresh([el.id]);
	            });
	        }
	
	        //for gallery external access
	        //expects an array of ids
	
	    }], [{
	        key: 'refreshSlots',
	        value: function refreshSlots(slotIds) {
	
	            var ids = slotIds || undefined;
	
	            console.log("Ads - slot external refresh " + ids);
	
	            //check if slot ids are passed
	            if (ids) {
	                time_dfp.refresh(slotIds);
	            } else {
	                time_dfp.refresh();
	            }
	        }
	    }]);
	
	    return Ads;
	}(_BannerAd3.default);
	
	exports.default = Ads;

/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BannerAd = function () {
		function BannerAd() {
			_classCallCheck(this, BannerAd);
	
			this.pinningStartedOnce = false;
		}
	
		_createClass(BannerAd, [{
			key: "enableBannerPinning",
			value: function enableBannerPinning() {
				var _this = this;
	
				console.log("ad size banner pin - start pinning");
	
				/*
	    'dfp.beforeInit',
	    'dfp.afterInit',
	    'dfp.updateCorrelator',
	    'dfp.defineSlot',
	    'dfp.slotBeforeDefine',
	    'dfp.slotAfterDefine',
	    'dfp.refresh',
	    'dfp.slotRefresh',
	    'dfp.slotRenderEnded'
	    */
	
				window.addEventListener('dfp.slotBeforeDefine', function (e) {
					if (!_this.pinningStartedOnce) {
						_this.registerSlotRendered();
						_this.pinningStartedOnce = true;
					}
				});
			}
		}, {
			key: "registerSlotRendered",
			value: function registerSlotRendered() {
	
				console.log("ad size banner pin - register slot rendered ");
	
				//we need to check googletag.pubads. When the googltag is not on the page, it causes js error on console
				if (typeof googletag.pubads === "function") {
	
					googletag.pubads().addEventListener('slotRenderEnded', this.onSlotRenderEnded.bind(this));
					googletag.pubads().addEventListener('impressionViewable', this.onImpressionViewable.bind(this));
				} else {
	
					console.error("Ads - googletag.pubads is not a function");
				}
			}
		}, {
			key: "onSlotRenderEnded",
			value: function onSlotRenderEnded(ev) {
	
				var slotId = ev.slot.getSlotElementId();
				var slotSize = ev.size.toString();
	
				//remove from refresh queue
				var queueIndex = this.refreshQueue.indexOf(slotId);
				queueIndex > -1 && this.refreshQueue.splice(queueIndex, 1);
	
				//conditional logging
				this.log("Ads - slot Rendered for: " + slotId + " size: " + slotSize);
				performance.mark("ADS_RENDER: ", slotSize);
	
				this.setPinning(slotSize);
			}
		}, {
			key: "onImpressionViewable",
			value: function onImpressionViewable(ev) {
	
				window.lastiv = ev;
	
				var slotId = ev.slot.getSlotElementId();
				var size = ev.slot.getSizes()[0] || "dfp - no size";
				//size = size.getWidth() + "," + size.getHeight();
	
				//conditional logging
				this.log("Ads - slot ImpressionViewable for: " + slotId + " size: " + size);
				performance.mark("ADS_VIEW: ", size);
			}
	
			//banner pinning logic
	
		}, {
			key: "setPinning",
			value: function setPinning(adSize) {
	
				var isPinnableBanner = adSize == '728,90' || adSize == '980,50' || adSize == '320,50' || adSize == '970,250' ? true : false;
	
				this.log("ad size banner pin " + adSize);
	
				if (isPinnableBanner) {
					this.setBodyBannerAdSize(adSize);
				}
			}
		}, {
			key: "setBodyBannerAdSize",
			value: function setBodyBannerAdSize(adSize) {
	
				document.body.setAttribute("data-banner-ad-size", adSize);
			}
		}]);
	
		return BannerAd;
	}();
	
	exports.default = BannerAd;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Viewports = __webpack_require__(15);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	var _scrollEvent = __webpack_require__(14);
	
	var _scrollEvent2 = _interopRequireDefault(_scrollEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BannerAdsPin = function () {
	    function BannerAdsPin() {
	        var _this = this;
	
	        _classCallCheck(this, BannerAdsPin);
	
	        this.bodyClassList = document.body.classList;
	        this.cachedScrollYpos = 0;
	        this.secNav = document.querySelector('.section-nav');
	        this.sidebar = document.querySelector('#sidebar');
	        this.isPin = false;
	        this.branchBannerHeight = 0;
	        this.globalNavH = 44;
	        this.unPinPos = 600;
	        this.bannerAdSizeAttr = null;
	        this.viewports = new _Viewports2.default();
	        this.winW = this.viewports.winW;
	        this.isiPad = this.viewports.isIPad;
	        this.viewPort = this.viewports.getViewPort();
	        this.rightRailElm = document.querySelector('.right-rail-wrapper');
	        this.bannerAdContiner = document.getElementById('banner-ad');
	        this.bannerOverlay = document.querySelector('.banner-ad-overlay');
	        this.allowAdSizes = ["728,90", "980,50", "320,50"];
	        this.timer = null;
	        this.adTimeLimit = 5000;
	        this.isClickedOn3things = false;
	
	        this.styleObj = {
	            bannerAdPin: 'banner-ad-pin',
	            mobileAdTransform: 'banner-ad-transform',
	            rightRailAdTransform: 'right-rail-transform'
	        };
	
	        window.addEventListener('dfp.slotRenderEnded', function (e) {
	            //data-banner-ad-size attribute is set only after the ad slot is rendered,
	            //so we need to access it after the ad slot is rendered
	            _this.bannerAdSizeAttr = document.querySelector('[data-banner-ad-size]');
	            _this.init();
	        });
	    }
	
	    _createClass(BannerAdsPin, [{
	        key: 'init',
	        value: function init() {
	            var _this2 = this;
	
	            if (this.hideNav()) {
	                this.bodyClassList.add('hideNav');
	            }
	
	            window.addEventListener("scroll", function () {
	                _scrollEvent2.default.debounce(200, _this2.onScroll());
	            });
	
	            document.body.addEventListener("click", function () {
	
	                //unpin banner ad when users click on outside the banner ad
	                if (_this2.isPin) {
	                    _this2.removePin();
	                }
	            });
	        }
	    }, {
	        key: 'getPromoHeight',
	        value: function getPromoHeight() {
	            var appPromoHeight = 0;
	            if (this.bodyClassList.contains('branch-banner-is-active')) {
	                appPromoHeight = 76;
	            }
	            return appPromoHeight;
	        }
	    }, {
	        key: 'getSecNavHeight',
	        value: function getSecNavHeight() {
	            return this.secNav ? this.secNav.offsetHeight : 0;
	        }
	    }, {
	        key: 'okToPin',
	        value: function okToPin() {
	
	            var okToPin = true;
	
	            /*
	             * we need to select data-banner-ad-size again here because EventListener('dfp.slotRenderEnded') is not triggered
	             * on any page that has no additional ad slots beside banner ex: media hub page
	             */
	            var adEl = this.bannerAdSizeAttr !== null ? this.bannerAdSizeAttr : document.querySelector('[data-banner-ad-size]');
	            var adSize = adEl && adEl.getAttribute("data-banner-ad-size");
	            var isSecNavOpen = this.bodyClassList.contains('secondary-menu-open');
	            var excludePageType = this.excludePageType();
	            var bannerHeight = this.bannerAdContiner ? this.bannerAdContiner.offsetHeight : 0;
	
	            /*
	             After Ads are rendered in the page, we update banner-ad-size attribute value in the Dom. See fsAdCollection.setBannerAdSize()
	             We don't want to pin the ad if the adSize is empty that means the ad is not created, or if the adSize is 970x250 because it
	             take up too much space in the window. We don't want to pin the ad if the second nav is open
	             we also don't want to pin the ad on open template because in some open template pages,
	             the contents were injected inside the adplaceholderBelowNavigation iparsys
	             */
	
	            if (!adSize || bannerHeight > 90 || this.allowAdSizes.indexOf(adSize) === -1 || isSecNavOpen || excludePageType) {
	                okToPin = false;
	            }
	            return okToPin;
	        }
	    }, {
	        key: 'hideNav',
	        value: function hideNav() {
	            return location.href.indexOf("nav=false") > -1 || document.cookie.indexOf("activeNavCookie=true") > -1 ? true : false;
	        }
	    }, {
	        key: 'excludePageType',
	        value: function excludePageType() {
	            var excludePageType = false;
	            if (this.bodyClassList.contains('fillnone') || this.bodyClassList.contains('blog-outkick-the-coverage') || this.bodyClassList.contains('story-outkick-the-coverage')) {
	                excludePageType = true;
	            }
	
	            return excludePageType;
	        }
	    }, {
	        key: 'removePin',
	        value: function removePin() {
	            this.bodyClassList.remove(this.styleObj.bannerAdPin);
	        }
	    }, {
	        key: 'stopTimer',
	        value: function stopTimer(timer) {
	            if (timer) {
	                window.clearTimeout(timer);
	                timer = null;
	            }
	        }
	
	        //pin the ad after scrolling position is surpassed the pinPos and un-pin the ad after timeout or scrolling position is less or equal than the pinPos
	
	    }, {
	        key: 'triggerScroll',
	        value: function triggerScroll(scrollDirection, scrollY) {
	            var _this3 = this;
	
	            var okToPin = this.okToPin();
	
	            if (okToPin) {
	                (function () {
	
	                    var pinPos = _this3.getSecNavHeight();
	                    var viewPort = _this3.viewPort;
	                    pinPos = pinPos + _this3.getPromoHeight();
	
	                    /**
	                     * pin banner ad when scrollY position passes preset pin position, and scrollY position is less than preset unpin position
	                     * don't activate ad pin when this.isClickedOn3things is true which means users click on the 3 things on the left rail
	                     * otherwise; the pinned ad will cover the top of the story on the 3 things
	                     **/
	                    if (!_this3.isPin && scrollDirection === 'down' && scrollY >= pinPos && !_this3.isClickedOn3things) {
	
	                        _this3.isPin = true;
	                        _this3.stopTimer(_this3.timer);
	
	                        _this3.bodyClassList.add(_this3.styleObj.bannerAdPin);
	                        _this3.bannerOverlay.style.transition = 'none';
	
	                        //setTimeout to remove ad pin after 3 seconds
	                        _this3.timer = setTimeout(function () {
	                            _this3.bannerOverlay.style.transition = null;
	                            if (_this3.sidebar) _this3.sidebar.style.transition = null;
	                            _this3.removePin();
	
	                            //checking (if this.cachedScrollYpos - scrollY > 0) to determine if users scroll backup right after scrolling down the page
	                            //we don't want to add banner-ad-transform class if users scroll backup to the top of the page within that 5 seconds
	                            //otherwise; the banner ad will be moved out from the page content and leave a empty space
	                            if (_this3.cachedScrollYpos - scrollY > 0) {
	
	                                if (viewPort === 'mobile') {
	                                    _this3.bodyClassList.add(_this3.styleObj.mobileAdTransform); //banner-ad-transform class adding the transition for sliding up
	                                } else if (_this3.rightRailElm && _this3.rightRailElm.style.position === "fixed") {
	                                    //apply right-rail-transform class if the right rail is pinned (has fixed position).
	                                    _this3.bodyClassList.add(_this3.styleObj.rightRailAdTransform);
	                                }
	                            }
	                        }, _this3.adTimeLimit);
	                    }
	
	                    if (scrollDirection === 'up' && scrollY <= pinPos) {
	                        _this3.removePin();
	                        if (viewPort === 'mobile') {
	                            _this3.bodyClassList.remove(_this3.styleObj.mobileAdTransform);
	                        }
	
	                        //when users scroll back up, reset this.isPin and this.isClickedOn3things to false
	                        _this3.isPin = false;
	                        _this3.isClickedOn3things = false;
	                    }
	                })();
	            }
	        }
	    }, {
	        key: 'onScroll',
	        value: function onScroll() {
	            var isMenuClosed = !this.bodyClassList.contains('global-menu-open') && !this.bodyClassList.contains('section-menu-open') && !this.bodyClassList.contains('scorestrip-open');
	
	            if (isMenuClosed) {
	
	                var scrollYpos = window.pageYOffset;
	                var scrollDistance = scrollYpos - this.cachedScrollYpos;
	                var scrollDirection = '';
	
	                /*
	                 * To ensure the scrolling direction is correct, we need to compare the distance that users scroll
	                 * to avoid down and up directions registered at the same time
	                 * because users just move the mouse 1px up and down
	                 * When users just move the mouse 1px up and down, scrollDirection will be empty,
	                 * if that is the case, we don't want to trigger pin event
	                 */
	                if (scrollDistance > 0) {
	                    scrollDirection = 'down';
	                } else if (scrollDistance < 0) {
	                    scrollDirection = 'up';
	                }
	
	                if ('' !== scrollDirection) {
	                    this.triggerScroll(scrollDirection, scrollYpos);
	                }
	
	                this.cachedScrollYpos = scrollYpos;
	            }
	        }
	    }]);
	
	    return BannerAdsPin;
	}();
	
	exports.default = new BannerAdsPin();

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _scrollEvent = __webpack_require__(14);
	
	var _scrollEvent2 = _interopRequireDefault(_scrollEvent);
	
	var _Viewports = __webpack_require__(15);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var skinAdsPin = function () {
	    function skinAdsPin() {
	        _classCallCheck(this, skinAdsPin);
	
	        this.skinAd = null;
	        this.skinAdElm = null;
	        this.skinAdPos = 0;
	        this.skinAdPinned = false;
	        this.skinAdPinTopPos = 0;
	        this.lastScrollTop = 0;
	        // elements
	        this.secNav = document.querySelector('.section-nav');
	        this.mainStory = document.getElementById("story-1");
	        this.secNavHeight = this.getSecNavHeight();
	        this.viewports = new _Viewports2.default();
	
	        this.init();
	    }
	
	    _createClass(skinAdsPin, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            window.addEventListener("scroll", function () {
	                _scrollEvent2.default.debounce(10, _this.toggleSkinAdPosOnScroll());
	            });
	        }
	    }, {
	        key: 'getSecNavHeight',
	        value: function getSecNavHeight() {
	            var secNav = this.secNav;
	            if (secNav !== undefined && secNav !== null) {
	                return secNav.offsetHeight;
	            }
	            return 0;
	        }
	    }, {
	        key: 'setSkinAdPos',
	        value: function setSkinAdPos(pos) {
	            this.skinAdPos = pos;
	        }
	    }, {
	        key: 'getSkinAdPos',
	        value: function getSkinAdPos() {
	            return this.skinAdPos;
	        }
	    }, {
	        key: 'hasSkinAd',
	        value: function hasSkinAd() {
	            this.skinAd = document.querySelector('.skin-bd');
	            if (this.skinAd) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'getSkinAdEl',
	        value: function getSkinAdEl() {
	            return document.getElementById('SkinContainer');
	        }
	    }, {
	        key: 'getSkinAdHeight',
	        value: function getSkinAdHeight() {
	            return this.skinAd.offsetHeight;
	        }
	    }, {
	        key: 'pinSkinAd',
	        value: function pinSkinAd(skinAdElm) {
	            skinAdElm.classList.remove('skinAdUnPin');
	            skinAdElm.classList.add('skinAdPin');
	        }
	    }, {
	        key: 'unPinSkinAd',
	        value: function unPinSkinAd(skinAdElm) {
	            skinAdElm.classList.remove('skinAdPin');
	            skinAdElm.classList.add('skinAdUnPin');
	        }
	    }, {
	        key: 'toggleSkinAdPosOnScroll',
	        value: function toggleSkinAdPosOnScroll() {
	
	            var st = window.pageYOffset || document.documentElement.scrollTop;
	            if (this.viewports.getViewPort() === 'desktop') {
	
	                var hasSkinAd = this.hasSkinAd();
	                var skinAdElm = this.getSkinAdEl();
	
	                if (hasSkinAd) {
	                    var skinAdHeight = this.getSkinAdHeight();
	                    var secNavHeight = this.secNavHeight;
	                    var mainStoryBottomPos = this.mainStory ? this.mainStory.getBoundingClientRect().bottom : 0;
	                    var bottomOffsetPos = skinAdHeight + secNavHeight;
	                    var isAdPinned = this.skinAdPinned;
	                    var offsets = parseInt(mainStoryBottomPos - 100.0);
	                    // Downscroll
	                    if (st > this.lastScrollTop) {
	                        if (st >= secNavHeight) {
	                            this.skinAd.style.transition = 'none';
	                            this.pinSkinAd(skinAdElm);
	                        }
	                        if (this.mainStory) {
	                            if (offsets <= bottomOffsetPos) {
	                                this.skinAd.style.transition = null;
	                                this.skinAd.classList.add('push-up');
	                            }
	                        }
	                    } else {
	                        if (st < this.lastScrollTop - 1) {
	                            if (st <= secNavHeight) {
	                                this.skinAd.style.transition = 'none';
	                                this.unPinSkinAd(skinAdElm);
	                            }
	                            if (this.mainStory) {
	                                if (offsets >= bottomOffsetPos) {
	                                    this.skinAd.classList.remove('push-up');
	                                }
	                            }
	                        }
	                    }
	                }
	                this.lastScrollTop = st;
	            }
	        }
	    }, {
	        key: 'updateSkinAdPosition',
	        value: function updateSkinAdPosition(i) {
	
	            var that = this,
	                position = that.skinAd.css('position'),
	                topPos = that.getSkinAdPos(),
	                skinAdPinTopPos = that.skinAdPinTopPos;
	
	            if (i === 2 && position !== 'absolute') {
	
	                that.skinAd.css({ position: 'absolute', top: topPos });
	            } else if (i === 1 && position !== 'fixed') {
	
	                that.skinAd.css({ position: 'fixed', top: skinAdPinTopPos });
	            }
	        }
	    }, {
	        key: 'toggleSkinAdPosOnClick',
	        value: function toggleSkinAdPosOnClick(mainStoryPos) {
	            //toggle skin ad when clicking three things
	
	            var that = this,
	                hasSkinAd = hasSkinAd || that.hasSkinAd();
	
	            if (hasSkinAd && mainStoryPos !== undefined) {
	
	                var skinAdHeight = that.getSkinAdHeight(),
	                    offset = storyProperties.belowNavAd.offsetHeight;
	
	                var unPinPos = mainStoryPos.bottom + offset - skinAdHeight;
	
	                that.setSkinAdPos(unPinPos);
	
	                that.updateSkinAdPosition(2);
	
	                that.skinAdPinned = false;
	            }
	        }
	    }]);
	
	    return skinAdsPin;
	}();
	
	exports.default = new skinAdsPin();

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _scrollEvent = __webpack_require__(14);
	
	var _scrollEvent2 = _interopRequireDefault(_scrollEvent);
	
	var _Viewports = __webpack_require__(15);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	var _screenLock = __webpack_require__(21);
	
	var _screenLock2 = _interopRequireDefault(_screenLock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScoreStrip = function () {
	    function ScoreStrip() {
	        _classCallCheck(this, ScoreStrip);
	
	        this.mobileMenuBtn = document.getElementById('nav-open-btn');
	        this.menu = document.getElementById(this.mobileMenuBtn.dataset.target);
	        this.bodyClassList = document.body.classList;
	        this.headerWrapper = document.getElementById('header-wrapper');
	        this.secondNav = document.querySelector('.section-nav');
	        this.globalNav = document.getElementById('global-nav');
	        this.globalNavWrapper = document.getElementsByClassName('global-nav-wrapper')[0];
	        this.globalNavOverlay = document.getElementById('global-nav-overlay');
	        this.globalNavDefault = document.querySelector('#sports-nav .menu-title');
	        this.globalNavContainer = document.querySelector('.global-nav-container');
	        this.globalNavHeight = this.globalNavContainer.offsetHeight || 0;
	        this.scoreStripButton = document.querySelector('.scorestrip-button');
	        this.scoreStripContainer = document.getElementById('ScorestripContainer');
	        this.scoreStripContainerBG = document.getElementById('scorestripContainerBG');
	        this.mActivator = document.querySelector('.m-nav-activator');
	        this.topLevel = document.querySelector('.section-nav .top-level');
	        this.throttle = 'ontouchstart' in document.documentElement ? 500 : 250;
	        this.branchBannerHeight = 76;
	
	        this.viewport = new _Viewports2.default({
	            'mobile': 767,
	            'desktop': 1024
	        });
	        this.screenLock = new _screenLock2.default();
	        this.setScoreStripViewportClassname();
	    }
	
	    _createClass(ScoreStrip, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            if (this.scoreStripButton !== null) {
	                (function () {
	                    var that = _this;
	                    that.scoreStripButton.addEventListener('click', function (ev) {
	                        if (window.scoreStrip) {
	                            that.toggleScorestrip();
	
	                            if (ev.preventDefault) ev.preventDefault();
	                            return false;
	                        }
	                        return;
	                    });
	
	                    _this.watchResize = _this.watchResize.bind(_this);
	                    _this.watchResize = _scrollEvent2.default.throttle(_this.watchResize, _this.throttle);
	                    window.addEventListener('resize', _this.watchResize);
	
	                    _this.setScoreStripViewportClassname();
	                })();
	            }
	        }
	    }, {
	        key: 'setScoreStripViewportClassname',
	        value: function setScoreStripViewportClassname() {
	
	            if (this.viewport.getViewPort() === 'mobile') {
	                this.bodyClassList.add('scorestrip-tall');
	                this.bodyClassList.remove('scorestrip-wide');
	            } else {
	                this.bodyClassList.add('scorestrip-wide');
	                this.bodyClassList.remove('scorestrip-tall');
	            }
	        }
	    }, {
	        key: 'open',
	        value: function open() {
	            if (this.bodyClassList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight) {
	                window.scrollTo(0, this.branchBannerHeight);
	            }
	            this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
	            this.screenLock.lockScreen();
	
	            this.bodyClassList.add('scorestrip-open');
	
	            //close second nav if opened
	            if (document.body.classList.contains('section-menu-open')) {
	                this.mActivator.classList.remove('is-active');
	                this.topLevel.classList.remove('is-active');
	                document.body.classList.remove('section-menu-open');
	            }
	
	            // close global nav if open
	            if (this.mobileMenuBtn.classList.contains('active')) {
	                this.mobileMenuBtn.classList.remove('active');
	                this.menu.classList.remove('active');
	                this.bodyClassList.remove('global-menu-open');
	                this.globalNavOverlay.classList.remove('show');
	                this.globalNavWrapper.classList.remove('show');
	                this.globalNavDefault.classList.remove('active');
	            }
	
	            if (window.scoreStrip) window.scoreStrip.maximize();
	        }
	    }, {
	        key: 'shut',
	        value: function shut() {
	            if (this.viewport.getViewPort() === 'tablet' || this.bodyClassList.contains('branch-banner-is-active')) {
	                this.globalNavWrapper.style.top = null;
	                this.headerWrapper.style.top = null;
	            }
	            this.bodyClassList.remove('scorestrip-open');
	            this.screenLock.unlockScreen();
	            if (window.scoreStrip) window.scoreStrip.minimize();
	        }
	    }, {
	        key: 'toggleScorestrip',
	        value: function toggleScorestrip() {
	            if (window.scoreStrip) {
	                if (this.bodyClassList.contains('scorestrip-open')) {
	                    this.shut();
	                } else {
	                    this.open();
	                }
	            }
	        }
	    }, {
	        key: 'watchResize',
	        value: function watchResize() {
	            this.viewport.setWinW(window.innerWidth);
	            this.setScoreStripViewportClassname();
	            if (this.bodyClassList.contains('scorestrip-open')) {
	                if (this.viewport.getViewPort() !== 'mobile' && window.scoreStrip) this.shut();
	            }
	        }
	    }]);
	
	    return ScoreStrip;
	}();
	
	exports.default = ScoreStrip;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Viewports = __webpack_require__(15);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var screenLock = function () {
	    function screenLock() {
	        _classCallCheck(this, screenLock);
	
	        this.body = document.getElementsByTagName('body')[0];
	        this.header = document.getElementById('header-wrapper');
	        this.secondNav = document.querySelector('.section-nav');
	        this.lastYOffset = 0;
	
	        this.viewport = new _Viewports2.default({
	            'mobile': 767
	        });
	    }
	
	    _createClass(screenLock, [{
	        key: 'lockScreen',
	        value: function lockScreen() {
	            this.lastYOffset = window.pageYOffset;
	            if (!this.body.classList.contains('screen-lock')) {
	                this.body.style.top = this.lastYOffset * -1 + 'px';
	                this.body.classList.add('screen-lock');
	            }
	            this.header.classList.add('visible');
	            if (this.secondNav) this.secondNav.classList.add('fixed');
	        }
	    }, {
	        key: 'unlockScreen',
	        value: function unlockScreen() {
	            var yPos = this.body.style.top.replace(/[^-\d\.]/g, '') * -1;
	            this.body.style.top = null;
	            this.header.classList.remove('visible');
	            if (this.secondNav) this.secondNav.classList.remove('fixed');
	            this.body.classList.remove('screen-lock');
	            window.scrollTo(0, yPos);
	        }
	    }]);
	
	    return screenLock;
	}();
	
	exports.default = screenLock;

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Handles the JavaScript associated with sidebar components
	 */
	
	var Sidebar = function Sidebar() {
		_classCallCheck(this, Sidebar);
	
		// Constants that won't change
		var timer = document.querySelectorAll('.sidebar-component-countdown-clock');
		var timerCount = timer.length;
	
		// Caching some variables
		var timeinterval;
		var jsMsgHook;
		var endtime;
		var clock;
		var i;
	
		// If there are timers on this page
		if (timerCount) {
	
			// Loop though them
			for (i = 0; i < timerCount; i = i + 1) {
	
				// Get the timer instance
				clock = timer[i];
	
				// Get the message instance
				jsMsgHook = clock.querySelector('.sidebar-message');
	
				// Get the Endtime
				endtime = clock.querySelector('.sidebar-timer__wrap').getAttribute('data-endtime');
	
				// Run the function once to avoid a delayed start
				updateClock(clock, endtime);
	
				// Set up the time interval to tick the clock down
				executeInterval(clock, endtime);
			} // for
		} // timerCount
	
		// Pulling this out of the loop
		function executeInterval(clock, endtime) {
	
			timeinterval = setInterval(function () {
	
				// Update the clock every second
				updateClock(clock, endtime);
			}, 1000);
		} // executeInterval()
	
		// Calculate the remaining time
		function getTimeRemaining(endtimeRaw) {
	
			// Some browsers need a "T" in there...
			var endtime = new Date(endtimeRaw.replace(/\s/, 'T'));
	
			// Eastern Time Offset
			var offset = -5.0;
			var clientDate = new Date();
			var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
			var current = new Date(utc + 3600000 * offset);
	
			var t = Date.parse(endtime) - Date.parse(current);
			var seconds = Math.floor(t / 1000 % 60);
			var minutes = Math.floor(t / 1000 / 60 % 60);
			var hours = Math.floor(t / (1000 * 60 * 60) % 24);
			var days = Math.floor(t / (1000 * 60 * 60 * 24));
	
			// Build out the JSON object
			return {
				'total': t,
				'days': days,
				'hours': hours,
				'minutes': minutes,
				'seconds': seconds
			};
		} // getTimeRemaining()
	
		// Update the DOM with the new time
		function updateClock(clock, endtime) {
	
			var expirationAction = clock.querySelector('.sidebar-timer__wrap').getAttribute('data-expiration');
			var t = getTimeRemaining(endtime);
			var days = clock.querySelector('.timer-days');
			var hours = clock.querySelector('.timer-hours');
			var minutes = clock.querySelector('.timer-minutes');
			var seconds = clock.querySelector('.timer-seconds');
	
			// Adds a leading 0 to maintain spacing
			days.querySelector('.sidebar-timer__value').innerHTML = ('0' + t.days).slice(-2);
			hours.querySelector('.sidebar-timer__value').innerHTML = ('0' + t.hours).slice(-2);
			minutes.querySelector('.sidebar-timer__value').innerHTML = ('0' + t.minutes).slice(-2);
			seconds.querySelector('.sidebar-timer__value').innerHTML = ('0' + t.seconds).slice(-2);
	
			if (t.total <= 0) {
	
				// Stop the timer
				clearInterval(timeinterval);
	
				// This likely won't display in the UI, but let's set it anyway.
				days.querySelector('.sidebar-timer__value').innerHTML = 0;
				hours.querySelector('.sidebar-timer__value').innerHTML = 0;
				minutes.querySelector('.sidebar-timer__value').innerHTML = 0;
				seconds.querySelector('.sidebar-timer__value').innerHTML = 0;
	
				// The timer has expired, so hide it
				clock.querySelector('.sidebar-timer').classList.add('is-removed');
				clock.querySelector('.sidebar-timer').classList.remove('is-active');
	
				// If we should be displaying the message upon expiration, do so now
				if (expirationAction === 'display-message') {
	
					clock.querySelector('.sidebar-message').classList.remove('is-removed');
					clock.querySelector('.sidebar-message').classList.remove('is-active');
				} else if (expirationAction === 'hide-component') {
	
					clock.classList.add('is-removed');
				} // if
			} // if
		} // updateClock()
	} // constructor()
	
	; // Sidebar {}
	
	exports.default = Sidebar;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _js = __webpack_require__(24);
	
	var _js2 = _interopRequireDefault(_js);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var forEach = function forEach(array, callback, scope) {
		for (var i = 0; i < array.length; i++) {
			callback.call(scope, i, array[i]); // passes back stuff we need
		}
	};
	
	var PromoBanner = function () {
		function PromoBanner() {
			_classCallCheck(this, PromoBanner);
	
			this.promoCheck();
		}
	
		_createClass(PromoBanner, [{
			key: 'promoCheck',
			value: function promoCheck() {
				var promos = document.querySelectorAll('.promo-footer');
				var promo_id;
				var promo_cookie;
				var dismiss_button;
				var dismiss_close;
	
				forEach(promos, function (index, value) {
					promo_id = value.getAttribute('id');
	
					promo_cookie = _js2.default.get('fsc-' + promo_id);
	
					if (undefined === promo_cookie) {
						value.classList.add('show-promo');
					} else {
						value.classList.add('hide-promo');
					}
	
					dismiss_button = document.getElementById('dismiss-' + promo_id);
	
					dismiss_button.addEventListener('click', function () {
	
						if (value.classList.contains('show-promo')) {
							value.classList.remove('show-promo');
							value.classList.add('hide-promo');
						}
	
						promo_id = value.getAttribute('id');
	
						_js2.default.set('fsc-' + promo_id, 'dismissed', { expires: 7 });
					});
	
					dismiss_close = document.getElementById('close-' + promo_id);
	
					dismiss_close.addEventListener('click', function () {
	
						if (value.classList.contains('show-promo')) {
							value.classList.remove('show-promo');
							value.classList.add('hide-promo');
						}
	
						promo_id = value.getAttribute('id');
	
						_js2.default.set('fsc-' + promo_id, 'closed', { expires: 7 });
					});
				});
			}
		}]);
	
		return PromoBanner;
	}();
	
	exports.default = new PromoBanner();

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * JavaScript Cookie v2.1.3
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (( false ? 'undefined' : _typeof(exports)) === 'object') {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	})(function () {
		function extend() {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[i];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init(converter) {
			function api(key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					return document.cookie = [key, '=', value, attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					attributes.path ? '; path=' + attributes.path : '', attributes.domain ? '; domain=' + attributes.domain : '', attributes.secure ? '; secure' : ''].join('');
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	});

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _navGlobal = __webpack_require__(26);
	
	var _navGlobal2 = _interopRequireDefault(_navGlobal);
	
	var _navSection = __webpack_require__(27);
	
	var _navSection2 = _interopRequireDefault(_navSection);
	
	var _navSectionSubnav = __webpack_require__(28);
	
	var _navSectionSubnav2 = _interopRequireDefault(_navSectionSubnav);
	
	var _NavSigninLoader = __webpack_require__(29);
	
	var _NavSigninLoader2 = _interopRequireDefault(_NavSigninLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _navGlobal2.default();
	var navSigninLoader = new _NavSigninLoader2.default();
	navSigninLoader.init();
	
	var topLevel = document.querySelector('.section-nav .top-level');
	
	if (null !== topLevel && topLevel !== undefined) {
	    new _navSection2.default();
	}
	
	var subNav = document.querySelector('.section-front-navigation');
	
	if (null !== subNav && subNav !== undefined) {
	    new _navSectionSubnav2.default();
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Handles the JavaScript associated with the Global navigation
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _scrollEvent = __webpack_require__(14);
	
	var _scrollEvent2 = _interopRequireDefault(_scrollEvent);
	
	var _Viewports = __webpack_require__(15);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	var _screenLock = __webpack_require__(21);
	
	var _screenLock2 = _interopRequireDefault(_screenLock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavGlobal = function () {
	
	    /**
	     * Intialize some variables for the Mobile Menu button and scroll positioning.
	     * Bind a scroll event listener to the window object and tie it to 'watch' function.
	     * Bind a click event listener to the mobile menu element and tie it to 'menuToggler' function.
	     *
	     * @since 0.1.0
	     */
	    function NavGlobal() {
	        var _this = this;
	
	        _classCallCheck(this, NavGlobal);
	
	        this.mobileMenuBtn = document.getElementById('nav-open-btn');
	        this.menu = document.getElementById(this.mobileMenuBtn.dataset.target);
	        this.bodyClassList = document.body.classList;
	        this.header = document.getElementById('header-wrapper');
	        this.secondNav = document.querySelector('.section-nav');
	        this.globalNav = document.getElementById('global-nav');
	        this.globalNavWrapper = document.querySelector('.global-nav-wrapper');
	        this.globalNavContainer = document.querySelector('.global-nav-container');
	        this.globalNavOverlay = document.getElementById('global-nav-overlay');
	        this.globalNavDefault = document.querySelector('#sports-nav .menu-title');
	        this.scoreStrip = document.querySelector('#ScorestripContainer');
	        this.innerMenu = document.querySelectorAll('#sports-nav > li.menu-title, #watch-nav > li, #fantasy-nav > li, #more-nav > li, #account-nav > li.logged-in, #follow-nav > li');
	        this.innerMenuLinks = document.querySelectorAll('#sports-nav > li.menu-title > a, #watch-nav > li > a, #fantasy-nav > li > a, #more-nav > li > a, #account-nav > li.logged-in > a, #follow-nav > li > a');
	        this.mActivator = document.querySelector('.m-nav-activator');
	        this.topLevel = document.querySelector('.section-nav .top-level');
	        this.navOverflow = document.querySelectorAll('.nav-overflow-more');
	        this.throttle = 'ontouchstart' in document.documentElement ? 50 : 10;
	        this.lastScrollTop = 0;
	        this.branchBannerHeight = 76;
	        this.scoreStripHeight = this.scoreStrip.offsetHeight || 75;
	        this.globalNavHeight = this.globalNavContainer.offsetHeight || 68;
	        this.isGlobalNavHidden = false;
	        this.bodyTagsAdded = false;
	        this.scorestripTagsAdded = false;
	        this.sidebar = document.querySelector('#sidebar');
	        this.sidebarClassList = this.sidebar ? this.sidebar.classList : null;
	        this.screenLock = new _screenLock2.default();
	
	        this.viewport = new _Viewports2.default({
	            'mobile': 767,
	            'desktop': 1024
	        });
	
	        // Adding a flag to the root element so we can hook into the template with CSS
	        document.documentElement.className += " js-loaded";
	
	        // Only bind the listener if the header exists.
	        if (null !== this.header) {
	            // bind "pin on scroll"
	            this.watch = this.watch.bind(this);
	            this.watch = _scrollEvent2.default.throttle(this.watch, this.throttle);
	            window.addEventListener('scroll', this.watch);
	
	            // bind "define offset on resize"
	            this.watchResize = this.watchResize.bind(this);
	            this.watchResize = _scrollEvent2.default.throttle(this.watchResize, this.throttle);
	            window.addEventListener('resize', this.watchResize);
	        }
	
	        // Only bind the listener if the mobile menu exists.
	        if (null !== this.mobileMenuBtn) {
	            this.mobileMenuBtn.addEventListener('click', function () {
	                return _this.menuToggler();
	            });
	        }
	
	        // Only bind the listener if an inner menu exists.
	        if (this.innerMenu.length > 0) {
	            Array.from(this.innerMenu).forEach(function (menu) {
	                menu.addEventListener('touchstart', function () {
	                    return _this.innerMenuToggler(menu);
	                });
	                menu.addEventListener('mouseover', function () {
	                    return _this.innerMenuToggler(menu);
	                });
	            });
	        }
	
	        // Only bind the listener if an inner menu exists.
	        if (this.innerMenuLinks.length > 0) {
	            Array.from(this.innerMenuLinks).forEach(function (link) {
	                link.addEventListener('touchstart', function (e) {
	                    return _this.innerMenuLinkToggler(link, e);
	                });
	                link.addEventListener('click', function (e) {
	                    return _this.innerMenuLinkToggler(link, e);
	                });
	            });
	        }
	
	        // Only bind the listener if an overflow menu links exists.
	        if (this.navOverflow.length > 0) {
	            Array.from(this.navOverflow).forEach(function (link) {
	                link.addEventListener('click', function (e) {
	                    e.preventDefault();
	                });
	            });
	        }
	    }
	
	    /**
	     * Handle toggling classes on the body, mobile menu button and mobile menu
	     * for CSS styling and visibility when the menu is toggled on smaller screens.
	     *
	     * @since 0.1.0
	     */
	
	
	    _createClass(NavGlobal, [{
	        key: 'menuToggler',
	        value: function menuToggler() {
	            /**
	             * If the mobile menu has the class 'active', remove it from the mobile menu,
	             * the mobile menu toggle and remove the body tag class 'global-menu-open'.
	             */
	            if (this.bodyClassList.contains('global-menu-open') || this.bodyClassList.contains('section-nav-open')) {
	                this.closeMenu();
	                // Otherwise, set these elements to their active classes.
	            } else {
	                this.openMenu();
	            }
	        }
	    }, {
	        key: 'closeMenu',
	        value: function closeMenu() {
	            this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
	            if (this.viewport.getViewPort() === 'tablet' || this.bodyClassList.contains('branch-banner-is-active')) {
	                this.globalNavWrapper.style.top = null;
	            }
	            this.mobileMenuBtn.classList.remove('active');
	            this.menu.classList.remove('active');
	            this.globalNavOverlay.classList.remove('show');
	            this.globalNavWrapper.classList.remove('show');
	            this.globalNavDefault.classList.remove('active');
	            this.bodyClassList.remove('global-menu-open');
	            this.screenLock.unlockScreen();
	
	            return this;
	        }
	    }, {
	        key: 'openMenu',
	        value: function openMenu() {
	            if (this.bodyClassList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight) {
	                window.scrollTo(0, this.branchBannerHeight);
	            }
	            this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
	            this.mobileMenuBtn.classList.add('active');
	            this.menu.classList.add('active');
	            this.globalNavOverlay.classList.add('show');
	            this.globalNavWrapper.classList.add('show');
	            // When opening the menu, always reset to sports menu
	            Array.from(this.innerMenu).forEach(function (item) {
	                item.classList.remove('active');
	            });
	            this.globalNavDefault.classList.add('active');
	            this.bodyClassList.add('global-menu-open');
	            this.setGlobalNavWrapperHeight();
	            this.screenLock.lockScreen();
	            //close second nav if opened
	            if (this.bodyClassList.contains('section-menu-open')) {
	                this.mActivator.classList.remove('is-active');
	                this.topLevel.classList.remove('is-active');
	                this.bodyClassList.remove('section-menu-open');
	            }
	            if (this.bodyClassList.contains('scorestrip-open')) {
	                if (window.scoreStrip) window.scoreStrip.minimize();
	                this.bodyClassList.remove('scorestrip-open');
	            }
	            return this;
	        }
	        /**
	         * Handle Adding/Removing 'active' from the inner menu item for mobile,
	         * effectively toggling a menu section's visibility.
	         */
	
	    }, {
	        key: 'innerMenuToggler',
	        value: function innerMenuToggler(menu) {
	            Array.from(this.innerMenu).forEach(function (menu) {
	                menu.classList.remove('active');
	            });
	            menu.classList.add('active');
	        }
	
	        /**
	         * Removes the linking of top-level items on touch or click
	         */
	
	    }, {
	        key: 'innerMenuLinkToggler',
	        value: function innerMenuLinkToggler(link, e) {
	            if (this.viewport.getViewPort() !== 'desktop') {
	                Array.from(this.innerMenuLinks).forEach(function (link) {
	                    e.preventDefault();
	                });
	            }
	        }
	
	        // stick - stick the navs
	
	    }, {
	        key: 'stick',
	        value: function stick() {
	            this.globalStick();
	            this.secondNavStick();
	        }
	        // unstick - unstick the navs
	
	    }, {
	        key: 'unstick',
	        value: function unstick() {
	            this.globalUnstick();
	            this.secondNavUnstick();
	        }
	    }, {
	        key: 'addAppBannerBodyTags',
	        value: function addAppBannerBodyTags() {
	            if (!this.bodyTagsAdded) {
	                this.bodyClassList.remove('appBannerDisplayed');
	                this.bodyClassList.add('appBannerHidden');
	                this.bodyTagsAdded = true;
	            }
	        }
	        // unstick for global nav
	
	    }, {
	        key: 'removeAppBannerBodyTags',
	        value: function removeAppBannerBodyTags() {
	            if (this.bodyTagsAdded && !this.bodyClassList.contains('section-menu-open')) {
	                this.bodyClassList.add('appBannerDisplayed');
	                this.bodyClassList.remove('appBannerHidden');
	                this.bodyTagsAdded = false;
	            }
	        }
	    }, {
	        key: 'hideGlobalNav',
	        value: function hideGlobalNav() {
	            if (!this.isGlobalNavHidden) {
	                //this.header.style.top = -this.globalNavHeight + 'px';
	                this.header.classList.add('push-up');
	                this.isGlobalNavHidden = true;
	            }
	        }
	    }, {
	        key: 'showGlobalNav',
	        value: function showGlobalNav() {
	            if (this.isGlobalNavHidden) {
	                this.header.classList.remove('push-up');
	                this.isGlobalNavHidden = false;
	            }
	        }
	    }, {
	        key: 'setGlobalNavWrapperHeight',
	        value: function setGlobalNavWrapperHeight() {
	            this.globalNavWrapper.style.height = window.innerHeight - 40 + 'px';
	        }
	    }, {
	        key: 'removeAllBodyClasses',
	        value: function removeAllBodyClasses() {
	            if (this.viewport.getViewPort() !== 'mobile') {
	                if (window.pageYOffset <= this.getYOffset()) {
	                    if (this.sidebarClassList) this.sidebarClassList.remove('fix');
	                }
	                if (this.viewport.winW >= 1024 && this.bodyClassList.contains('scorestripHidden')) {
	                    this.hideGlobalNav();
	                } else {
	                    this.showGlobalNav();
	                }
	            }
	        }
	    }, {
	        key: 'toggleSticky',
	        value: function toggleSticky(stickPoint) {
	            var scrollPos = window.pageYOffset || document.documentElement.scrollTop;
	            var scorestripPresent = this.bodyClassList.contains('scorestrip-wide');
	            if (this.bodyClassList.contains('branch-banner-is-active')) {
	                if (scrollPos > stickPoint) {
	                    this.addAppBannerBodyTags();
	                } else {
	                    this.removeAppBannerBodyTags();
	                }
	            }
	        }
	        // getYOffset = get Y offset
	
	    }, {
	        key: 'getYOffset',
	        value: function getYOffset() {
	            if (this.bodyClassList.contains('branch-banner-is-active')) {
	                return this.branchBannerHeight;
	            } else {
	                return 0;
	            }
	        }
	        /**
	         * Watch for scrolling changes in direction.
	         *
	         * @since 0.1.0
	         */
	
	    }, {
	        key: 'watch',
	        value: function watch() {
	
	            if (this.bodyClassList.contains('global-menu-open') || document.body.classList.contains('scorestrip-open')) return;
	            var pinPos = this.getYOffset();
	
	            var st = window.pageYOffset || document.documentElement.scrollTop;
	            // Desktop
	            if (this.viewport.getViewPort() == 'desktop') {
	                // Downscroll
	                if (st > this.lastScrollTop) {
	                    if (st > pinPos) {
	                        this.addAppBannerBodyTags();
	                    }
	                    // Upscroll
	                } else {
	                    if (st < this.lastScrollTop - 1) {
	                        if (st < pinPos) {
	                            this.removeAppBannerBodyTags();
	                        }
	                    }
	                }
	            } else {
	                // Mobile/Tablet
	                this.toggleSticky(this.getYOffset());
	            }
	            // Update the lastScrollTop value to the page's offset.
	            this.lastScrollTop = st;
	        }
	        /**
	         * Watch for resize and orientation change.
	         */
	
	    }, {
	        key: 'watchResize',
	        value: function watchResize() {
	            this.viewport.setWinW(window.innerWidth);
	            this.globalNavHeight = this.globalNavContainer.offsetHeight;
	            if (this.globalNavWrapper.classList.contains('show') && this.viewport.winW >= 1024) {
	                this.closeMenu();
	            } else if (this.globalNavWrapper.classList.contains('show')) {
	                this.setGlobalNavWrapperHeight();
	            }
	            //removes body tags when resizing
	            this.removeAllBodyClasses();
	        }
	    }]);
	
	    return NavGlobal;
	}();
	
	exports.default = NavGlobal;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Handles the JavaScript associated with the Section navigation
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _scrollEvent = __webpack_require__(14);
	
	var _scrollEvent2 = _interopRequireDefault(_scrollEvent);
	
	var _screenLock = __webpack_require__(21);
	
	var _screenLock2 = _interopRequireDefault(_screenLock);
	
	var _Viewports = __webpack_require__(15);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var forEach = function forEach(array, callback, scope) {
	    for (var i = 0; i < array.length; i++) {
	        callback.call(scope, i, array[i]); // passes back stuff we need
	    }
	};
	
	var NavSection = function () {
	    function NavSection() {
	        var _this = this;
	
	        _classCallCheck(this, NavSection);
	
	        var subNavParents = document.querySelectorAll('.section-nav li.menu-item-has-children > a');
	        var subNav = document.querySelectorAll('.section-nav .top-level .sub-menu');
	        var subNavBackHtml = '<span class="sub-menu-back">Back</span>';
	        var moreOverflow = document.querySelector('.section-more');
	        var sectionNav = document.querySelector('.section-nav');
	
	        this.throttle = 'ontouchstart' in document.documentElement ? 100 : 10;
	        this.topLevel = document.querySelector('.section-nav .top-level');
	        this.sectionNavChildCount = this.topLevel.childElementCount;
	        this.sectionNavChildren = this.topLevel.children;
	        this.mActivator = document.querySelector('.m-nav-activator');
	        this.globalNav = document.querySelector('.global-nav-container');
	        this.globalNavHeight = this.globalNav.offsetHeight;
	        this.header = document.getElementById('js-body-header');
	        this.screenLock = new _screenLock2.default();
	        this.branchBannerHeight = 76;
	
	        // Let the CSS know we have touch available
	        if ('ontouchstart' in window || navigator.maxTouchPoints) {
	            document.documentElement.className += " has-touch";
	        } else {
	            document.documentElement.className += " no-touch";
	        }
	
	        // Set up the initial team menu state before any page-level evaluation happens
	        this.removeTeamDropdownMenu();
	
	        // Set up the watch menus
	        this.navWatchTitleLink();
	
	        /**
	         * Hides the "More" navigation item until it has been determined to be
	         * either empty or populated in order to prevent the user from seeing it
	         * in an unfinished state.
	         */
	        moreOverflow.style.display = 'none';
	
	        this.mActivator.addEventListener('click', function (e) {
	            return _this.mobileNavToggle(e);
	        });
	
	        // uncomment when when resume sec nav pinning
	        // bind "pin on scroll"
	        // this.navSticker = this.navSticker.bind(this);
	        // this.navSticker = scrollEvent.throttle(this.navSticker, this.throttle);
	        // window.addEventListener('scroll', this.navSticker);
	        document.addEventListener('DOMContentLoaded', function () {
	            return _this.moreMenuBuilder();
	        });
	        document.addEventListener('DOMContentLoaded', function () {
	            return _this.moveTeamDisplayMenu();
	        });
	        document.addEventListener('DOMContentLoaded', function () {
	            return _this.buildTeamSlider();
	        });
	
	        window.addEventListener('resize', function () {
	            _scrollEvent2.default.debounce(100, _this.moveTeamDisplayMenu());
	        });
	
	        forEach(subNavParents, function (index, value) {
	            var subNavAnchor = value;
	            var subNavLi = value.parentNode;
	            var resizeTimeout;
	
	            // Prevent resize from firing for every pixel resized, instead ensure a short delay.
	            function resizeThrottler() {
	                // ignore resize events as long as an actualResizeHandler execution is in the queue
	                if (!resizeTimeout) {
	                    resizeTimeout = setTimeout(function () {
	                        resizeTimeout = null;
	                        hoverDetector();
	
	                        // The actualResizeHandler will execute at a rate of 15fps
	                    }, 66);
	                }
	            }
	
	            /**
	             * Detect wether the sub navigation should be opened on hover or click
	             * depending on screen size.
	             */
	            function hoverDetector() {
	                var winWidth = window.innerWidth;
	                if (winWidth >= 1024) {
	                    subNavLi.classList.add('hover');
	                } else {
	                    subNavLi.classList.remove('hover');
	                    subNavAnchor.addEventListener('click', activeListener, false);
	                }
	            }
	
	            /**
	             * Function to handle when the sub-navigation should appear on click.
	             */
	            function activeListener(e) {
	                var winWidth = window.innerWidth;
	                if (winWidth < 768) {
	                    e.preventDefault();
	                }
	
	                var subNavParentsActive = document.querySelectorAll('.section-nav li.menu-item-has-children.is-active');
	
	                if (subNavLi.classList.contains('is-active') && !subNavLi.classList.contains('hover')) {
	                    subNavLi.classList.remove('is-active');
	                } else if (subNavLi.classList.contains('is-active') && subNavLi.classList.contains('hover')) {
	                    subNavLi.classList.remove('is-active');
	                    subNavLi.classList.remove('hover');
	                } else {
	                    forEach(subNavParentsActive, function (index, value) {
	                        value.classList.remove('is-active');
	                    });
	                    subNavLi.classList.add('is-active');
	                }
	            }
	
	            hoverDetector();
	            window.addEventListener('resize', resizeThrottler, false);
	        });
	
	        // Add the HTML pertaining to the "Back" button on mobile sub-navigation menus.
	        forEach(subNav, function (index, value) {
	            var subNavLocal = value.querySelector('li:first-of-type');
	
	            subNavLocal.insertAdjacentHTML('beforebegin', subNavBackHtml);
	        });
	
	        // Define subNavBack after it has been inserted by the JS
	        var subNavBack = document.querySelectorAll('.section-nav .sub-menu .sub-menu-back');
	
	        // For each subNavBack, remove active class on click.
	        forEach(subNavBack, function (index, value) {
	            var subNavBackParent = value.parentNode.parentNode;
	
	            value.addEventListener('click', function () {
	
	                if (subNavBackParent.classList.contains('is-active')) {
	                    subNavBackParent.classList.remove('is-active');
	                }
	            });
	        });
	    }
	
	    /**
	     * Function to toggle classes for the mobile navigation.
	     */
	
	
	    _createClass(NavSection, [{
	        key: 'mobileNavToggle',
	        value: function mobileNavToggle(e) {
	            e.preventDefault();
	            this.mActivator.classList.toggle('is-active');
	            this.topLevel.classList.toggle('is-active');
	            document.body.classList.toggle('section-menu-open');
	            if (document.body.classList.contains('section-menu-open')) {
	                if (document.body.classList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight) {
	                    window.scrollTo(0, this.branchBannerHeight);
	                }
	                this.screenLock.lockScreen();
	            } else {
	                this.screenLock.unlockScreen();
	            }
	        }
	        // uncomment when when resume sec nav pinning
	        // /**
	        //  * Stick the section navigation to the top as the user scrolls down.
	        //  * Accounts for logged in users as well as logged out.
	        //  */
	        // navSticker() {
	        // 	var scrollTimeout;
	        // 	// ignore scroll events as long as an actualResizeHandler execution is in the queue
	        // 	if (!scrollTimeout) {
	        // 		scrollTimeout = setTimeout(function() {
	        // 			scrollTimeout = null;
	
	        // 			var wpAdmin = document.getElementById('wpadminbar');
	        // 			this.sectionNav = document.querySelector('.section-nav'),
	        // 				this.globalNav = document.querySelector('.global-nav-container'),
	        // 				this.globalNavHeight = this.globalNav.offsetHeight;
	
	        // 			if (null !== wpAdmin) {
	        // 				var wpAdminHeight = wpAdmin.offsetHeight;
	        // 			}
	
	        // 			if (this.globalNavHeight <= window.pageYOffset && wpAdmin === null) {
	        // 				this.sectionNav.classList.add('fixed');
	        // 				if (null !== wpAdmin) {
	        // 					this.sectionNav.style.top = wpAdminHeight + 'px';
	        // 				} else {
	        // 					this.sectionNav.style.top = '0';
	        // 				}
	        // 			} else if (this.globalNavHeight + wpAdminHeight <= window.pageYOffset + wpAdminHeight) {
	        // 				this.sectionNav.classList.add('fixed');
	        // 				if (null !== wpAdmin) {
	        // 					this.sectionNav.style.top = wpAdminHeight + 'px';
	        // 				} else {
	        // 					this.sectionNav.style.top = '0';
	        // 				}
	        // 			} else {
	        // 				this.sectionNav.classList.remove('fixed');
	        // 				this.sectionNav.style.top = null;
	        // 			}
	        // 			// The actualResizeHandler will execute at a rate of 15fps
	        // 		}, 66);
	        // 	}
	        // }
	
	        /**
	         * Build the more navigation based on space available in the top menu
	         */
	
	    }, {
	        key: 'moreMenuBuilder',
	        value: function moreMenuBuilder() {
	            var sectionNavMore = document.querySelector(' .section-more ');
	            var sectionNavMoreSub = document.querySelector('.section-more .sub-menu');
	            var menu = document.querySelector('.section-nav-wrap .menu');
	            var topMenu = menu.querySelector('.top-level');
	            var self = this;
	
	            this.buildMoreMenu(menu, sectionNavMore, sectionNavMoreSub);
	
	            // add scroll buttons to teams menu
	            this.addClickScrollToTeamsMenu();
	
	            window.addEventListener('resize', function () {
	                _scrollEvent2.default.debounce(100, self.resetAndBuild(menu, topMenu, sectionNavMore, sectionNavMoreSub));
	
	                // add scroll buttons to teams menu
	                _scrollEvent2.default.debounce(100, self.addClickScrollToTeamsMenu);
	            });
	        }
	    }, {
	        key: 'resetAndBuild',
	        value: function resetAndBuild(menu, topMenu, moreLink, moreMenu) {
	            // Reset more menu and recount items that fit in the menu
	            this.resetMoreMenu(moreLink, topMenu, menu);
	            this.buildMoreMenu(menu, moreLink, moreMenu);
	        }
	
	        /**
	         * Helper method to add multiple attribute to an element at once
	         */
	
	    }, {
	        key: 'setAttributes',
	        value: function setAttributes(el, attrs) {
	            for (var key in attrs) {
	                el.setAttribute(key, attrs[key]);
	            }
	        }
	
	        /**
	         * Clone the "Tune In" menu item for The Herd and stick it above the content area on small screen
	         */
	
	    }, {
	        key: 'cloneTuneInMenu',
	        value: function cloneTuneInMenu(menuTuneIn) {
	
	            var menuTuneInContent = menuTuneIn.innerHTML;
	            var bodyContent = document.querySelector('.body-content');
	            var bannerAdContainer = document.querySelector('.banner-ad-container');
	            var holderParentElement;
	
	            // if bodyContent and bannerAdContainer are not on the page, fail silently
	            if (!bodyContent && !bannerAdContainer) {
	                return;
	            }
	
	            // if bodyContent exists, but bannerAdContainer doesn't, move forward with bodyContent
	            if (bodyContent && !bannerAdContainer) {
	                holderParentElement = bodyContent.parentNode;
	            }
	
	            var viewports = new _Viewports2.default();
	
	            // Create a target element to move .menu-tune-in contents on small screen
	            var cloneTarget = document.createElement('div');
	            var cloneCatcher = document.createElement('div');
	
	            // Setting up this area to revieve content for viewing and assitive technology
	            this.setAttributes(cloneTarget, {
	                'class': 'menu-tune-in__clone',
	                'id': 'menu-tune-in__clone',
	                'aria-live': 'polite',
	                'aria-atomic': 'true',
	                'aria-relvent': 'additions removals'
	            });
	
	            // Create an area to catch the content
	            this.setAttributes(cloneCatcher, {
	                'class': 'menu-tune-in',
	                'id': 'menu-tune-in__catcher'
	            });
	
	            // Combine the two elements
	            cloneTarget.appendChild(cloneCatcher);
	
	            // making sure this only runs once
	            if (!document.getElementById('menu-tune-in__clone')) {
	
	                // if bannerAdContainer exists, use it, otherwise check for bodyContent
	                if (bannerAdContainer) {
	                    bannerAdContainer.parentNode.insertBefore(cloneTarget, bannerAdContainer.nextSibling);
	                } else if (bodyContent) {
	                    holderParentElement.insertBefore(cloneTarget, bodyContent);
	                }
	            } // check for clone in the DOM
	
	            // Add the cloned content into the catcher if on small screen
	            if ('mobile' === viewports.getViewPort(this.winW)) {
	
	                // Hide the menu LI from view and assitive technology
	                menuTuneIn.style.display = 'none';
	                menuTuneIn.setAttribute('aria-hidden', 'true');
	
	                // Add the new item into the DOM
	                document.getElementById('menu-tune-in__clone').setAttribute('aria-hidden', 'false');
	                document.getElementById('menu-tune-in__catcher').innerHTML = menuTuneInContent;
	            } else {
	
	                // Show the original menu item LI
	                menuTuneIn.removeAttribute('style');
	                menuTuneIn.setAttribute('aria-hidden', 'false');
	
	                // Remove this item from the DOM
	                document.getElementById('menu-tune-in__clone').setAttribute('aria-hidden', 'true');
	                document.getElementById('menu-tune-in__catcher').innerHTML = '';
	            }
	        } // this.cloneTuneInMenu();
	
	    }, {
	        key: 'buildMoreMenu',
	        value: function buildMoreMenu(menu, moreLink, moreMenu) {
	            var wrapper = document.querySelector('.section-nav-wrap');
	            var menuTuneIn = document.querySelector('.menu-tune-in');
	            var menuTopLevelItems = menu.querySelectorAll('.top-level > li.menu-item');
	            var menuTitle = menu.querySelector('.menu-title');
	            var menuTopLevelItemsCount = menuTopLevelItems.length - 1; // Remove the placeholder More top level item
	
	            var fragment = document.createDocumentFragment();
	
	            var viewports = new _Viewports2.default();
	            var menuTitleWidth = menuTitle.offsetWidth;
	
	            // The title is full width on a different line in those menus
	            if (menu.parentNode.parentNode.classList.contains('team-nav') || menu.parentNode.parentNode.classList.contains('watch-nav')) {
	                menuTitleWidth = 0;
	            }
	            var wrapperStyles = getComputedStyle(wrapper);
	            var wrapperWidth = parseInt(wrapperStyles.width, 10) - parseInt(wrapperStyles.paddingLeft, 10) - parseInt(wrapperStyles.paddingRight, 10) - menuTitleWidth;
	            var menuWidth = parseInt(wrapperWidth - 300, 10); // Allow us a 300px gap to fit eventual More link
	            var moreSubItems = 0;
	            var tempWidth = 0;
	            var breakIndex = 0;
	            var i = 0;
	
	            if (menuTuneIn) {
	
	                menuWidth = menuWidth - menuTuneIn.offsetWidth;
	
	                this.cloneTuneInMenu(menuTuneIn);
	            }
	
	            // Loop through menu top level items and add up their width
	            // Stop while the added widths are smaller than the available space
	            do {
	                breakIndex = i;
	                tempWidth += menuTopLevelItems[i].offsetWidth;
	                i++;
	            } while (tempWidth < menuWidth && i <= menuTopLevelItemsCount);
	
	            // On small screens, we want exactly 10 links, counting More link
	            if ('mobile' === viewports.getViewPort(this.winW)) {
	                breakIndex = 9;
	            }
	
	            // Count how many submenu items we are left with
	            moreSubItems = menuTopLevelItemsCount - breakIndex;
	
	            // Move items that don't fit in the More submenu if there is more than one
	            // Display more link
	            if (breakIndex < menuTopLevelItemsCount && moreSubItems > 1) {
	
	                for (var j = breakIndex; j < menuTopLevelItemsCount; j++) {
	
	                    moreMenu.appendChild(menuTopLevelItems[j]);
	                } // for
	
	                // remove the style attribute instead of setting the inline CSS
	                moreLink.removeAttribute('style');
	            } // if
	
	            // Menu checks done, add class loaded
	            menu.classList.add('loaded');
	        } // buildMoreMenu()
	
	    }, {
	        key: 'resetMoreMenu',
	        value: function resetMoreMenu(moreMenu, topMenu, menu) {
	
	            var menuTuneIn = document.querySelector('.menu-tune-in');
	            var moreSubMenu = moreMenu.querySelector('.sub-menu');
	            var moreMenuItems = moreSubMenu.childNodes;
	
	            // If the moreMenuItems container doesn't exist, bail out
	            if (!moreMenuItems) {
	                return;
	            }
	
	            var moreMenuItemsCount = moreMenuItems.length;
	            var separatorItem = moreMenu;
	            var i;
	
	            // If menu tune in is present, insert items before the tune in <li>
	            if (menuTuneIn) {
	                separatorItem = menuTuneIn;
	            }
	
	            // For each item in More submenu, add it back to the top menu
	            if (moreMenuItemsCount >= 0) {
	                for (i = 0; i < moreMenuItemsCount; i++) {
	
	                    // I need this because there's a SPAN in the UL that needs to stay there
	                    if (moreMenuItems[i] && moreMenuItems[i].nodeName === 'LI' && moreMenuItems[i].innerHTML !== '') {
	                        topMenu.insertBefore(moreMenuItems[i], separatorItem);
	                    }
	                }
	            }
	
	            // Hide the more link
	            moreMenu.style.display = 'none';
	
	            // Failsafe check to see if there are any items in the menu, if so, show it.
	            if (moreMenu.querySelectorAll('.menu-item').length !== 0) {
	                moreMenu.removeAttribute('style');
	            }
	
	            // Restore menu class
	            menu.classList.remove('loaded');
	        } // resetMoreMenu()
	
	        /**
	         * Move team display menu in small screen
	         */
	
	    }, {
	        key: 'moveTeamDisplayMenu',
	        value: function moveTeamDisplayMenu() {
	            var teamDisplayMenu = document.querySelector('.local-team-display--wrapper');
	            var viewports = new _Viewports2.default();
	
	            // if the teamDisplayMenu doesn't exist, don't bother
	            if (!teamDisplayMenu) {
	                return;
	            }
	
	            if ('mobile' === viewports.getViewPort()) {
	                // Move team display menu to top of top-level menu on small screen
	                if (!this.topLevel.querySelector('.local-team-display--wrapper')) {
	                    this.topLevel.insertBefore(teamDisplayMenu, this.topLevel.firstChild);
	                }
	            } else {
	                document.querySelector('.section-nav-wrap > ul').appendChild(teamDisplayMenu);
	            }
	        }
	
	        /**
	         * Get the total width of an object
	         */
	
	    }, {
	        key: 'getTotalWidth',
	        value: function getTotalWidth(obj) {
	
	            if (!obj) {
	                return;
	            }
	
	            var style = obj.currentStyle || window.getComputedStyle(obj);
	            var objWidth = obj.offsetWidth; // includes padding
	            var objMargin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
	            var objBorder = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
	            var totalObjWidth = objWidth + objMargin + objBorder;
	
	            return totalObjWidth;
	        }
	
	        /**
	         * Add click scrolling to team menu
	         */
	
	    }, {
	        key: 'addClickScrollToTeamsMenu',
	        value: function addClickScrollToTeamsMenu() {
	
	            // Setting and caching some variables
	            var teamMenuWrapper = document.querySelector('.local-team-display--wrapper');
	
	            // if the teamMenuWrapper isn't there, bail out
	            if (!teamMenuWrapper) {
	                return;
	            }
	
	            var teamMenu = document.querySelector('.local-team-display');
	            var teamMenuWidth = this.getTotalWidth(teamMenu);
	            var teamMenuItems = teamMenu.querySelectorAll('.menu-item');
	            var teamMenuItemCount = teamMenuItems.length;
	            var teamMenuTotalWidth = 0;
	            var i;
	            var obj;
	            var objWidthCalc;
	
	            // Loop through all the menu items to calculate the width needed to display without a scrollbar
	            for (i = 0; i < teamMenuItemCount; i = i + 1) {
	                obj = teamMenuItems[i];
	                objWidthCalc = this.getTotalWidth(obj);
	
	                // Get the total width of the menu
	                teamMenuTotalWidth = teamMenuTotalWidth + objWidthCalc;
	            }
	
	            // Check to make sure the content area is scrollable
	            if (teamMenuTotalWidth >= teamMenuWidth) {
	                teamMenuWrapper.classList.add('has-overflow');
	            } else {
	                teamMenuWrapper.classList.remove('has-overflow');
	            }
	        }
	
	        /**
	         * Build out the team slider menu, if it exists
	         */
	
	    }, {
	        key: 'buildTeamSlider',
	        value: function buildTeamSlider() {
	
	            var teamMenuWrapper = document.querySelector('.local-team-display--wrapper');
	            var teamMenu = document.querySelector('.local-team-display');
	
	            // If there's no teamMenuWrapper, bail out
	            if (!teamMenuWrapper) {
	                return;
	            }
	
	            // Prep the UI for scroll buttons
	            var prev = document.createElement('button');
	            var next = document.createElement('button');
	
	            // Add a body class to help with the extra height
	            document.body.classList.add('contains-team-display-menu');
	
	            // Build out the previous button
	            prev.setAttribute('type', 'button');
	            prev.setAttribute('aria-hidden', 'true'); // a screen reader can read the list items with out the control
	            prev.setAttribute('class', 'btn-prev');
	            prev.setAttribute('id', 'btn-prev');
	            prev.innerHTML = 'Previous';
	
	            // Build out the next button
	            next.setAttribute('type', 'button');
	            next.setAttribute('aria-hidden', 'true'); // a screen reader can read the list items with out the control
	            next.setAttribute('class', 'btn-next');
	            next.setAttribute('id', 'btn-next');
	            next.innerHTML = 'Next';
	
	            // The next button into the UI (once)
	            if (!document.getElementById('btn-next')) {
	                teamMenuWrapper.appendChild(next);
	            }
	
	            // Add the previous button into the UI (once)
	            if (!document.getElementById('btn-prev')) {
	                teamMenuWrapper.insertBefore(prev, teamMenuWrapper.firstChild);
	            }
	
	            // Event binding for "previous/scroll" button
	            document.getElementById('btn-prev').addEventListener('click', function () {
	
	                // scroll the div
	                teamMenu.scrollLeft = 0; // scroll to 0 position
	
	                // Let the CSS know what's going on
	                teamMenuWrapper.classList.add('scrolled-to-the-left');
	                teamMenuWrapper.classList.remove('scrolled-to-the-right');
	            });
	
	            // Event binding for "next/scroll" button
	            document.getElementById('btn-next').addEventListener('click', function () {
	
	                // scroll the div
	                teamMenu.scrollLeft = 1000; // scroll to the end
	
	                // Let the CSS know what's going on
	                teamMenuWrapper.classList.add('scrolled-to-the-right');
	                teamMenuWrapper.classList.remove('scrolled-to-the-left');
	            });
	        } // buildTeamSlider()
	
	        /**
	         * Modify the team-based navigation if we can/need to
	         */
	
	    }, {
	        key: 'removeTeamDropdownMenu',
	        value: function removeTeamDropdownMenu() {
	
	            // Get the container nav container when it is telling us the team display is present
	            var teamDisplayFlag = document.querySelector('.has-team-display');
	
	            // Cache these variable for later use
	            var teamDropdropMenu;
	            var localTeamDisplay;
	
	            // If the team display flag is in the UI, move forward
	            if (teamDisplayFlag) {
	
	                // Get the team dropdown menu by className
	                teamDropdropMenu = teamDisplayFlag.querySelector('.narrow-team');
	                localTeamDisplay = teamDisplayFlag.querySelector('.local-team-display');
	
	                // Check to make sure the larger team display exists before removing the dropdown menu
	                if (localTeamDisplay) {
	
	                    // Make sure the menu is here before I try to remove it
	                    if (teamDropdropMenu) {
	
	                        // Remove the menu item, because we're using a larger version of it elsewhere in the UI
	                        teamDropdropMenu.parentNode.removeChild(teamDropdropMenu);
	                    }
	                } else {
	
	                    // If for some reason the container is telling us the larger menu should be there, but it isn't, remove the class so the UI doesn't break
	                    teamDisplayFlag.classList.remove('has-team-display');
	                } // teamDropdropMenu && localTeamDisplay
	            } // if teamDisplayFlag
	        } // removeTeamDropdownMenu()
	
	        /**
	         * Make the navigation title of a watch template a link
	         */
	
	    }, {
	        key: 'navWatchTitleLink',
	        value: function navWatchTitleLink() {
	
	            var watchNav = document.querySelector('.watch-nav');
	
	            // If the watchNav isn't available, bail out.
	            if (!watchNav) {
	                return;
	            }
	
	            // Gather some variables to work with
	            var watchNavTitle = watchNav.querySelector('.menu-title'); // scope down to the watch navigation menu
	            var watchNavTitleSpan = watchNavTitle.querySelector('span'); // get the span inside the navTitle
	            var watchNavTitleSpanText = watchNavTitleSpan.innerHTML; // Get the span text, so we can rebuild the link later
	            var topLevelNavigation = watchNav.querySelector('.top-level'); // scope down the the toplevel nav object
	            var firstLink = topLevelNavigation.querySelectorAll('a')[0]; // get the anchor
	            var firstLinkHref = firstLink.getAttribute('href'); // get the href
	            var firstLinkTitle = firstLink.getAttribute('title'); // get the href
	            var firstLinkText = firstLink.text; // get the anchor text
	            var firstLinkTextLowercase = firstLinkText.toLowerCase(); // make the word lowercase
	            var firstLinkTextClean = firstLinkTextLowercase.replace(/ /g, ''); // remove all whitespace
	
	            // Get the menu Logo link
	            var menuLogoLink = watchNav.querySelector('.menu-logo-overlay');
	
	            // Create a new link that will be inserted into the DOM
	            var newHomeLink = document.createElement('a');
	
	            // Make sure the link is labeled as "home"
	            if (firstLinkTextClean === 'home') {
	
	                if (menuLogoLink) {
	                    // Set properties of the logo overlay
	                    menuLogoLink.setAttribute('href', firstLinkHref);
	                    menuLogoLink.setAttribute('title', firstLinkTitle);
	                    menuLogoLink.innerHTML = watchNavTitleSpanText;
	                }
	
	                // Build out the link
	                newHomeLink.setAttribute('href', firstLinkHref);
	
	                // Add a title attr if it exists, otherwise don't worry about it
	                if (firstLinkTitle) {
	                    newHomeLink.setAttribute('title', firstLinkTitle);
	                }
	
	                // Set the link text
	                newHomeLink.innerHTML = watchNavTitleSpanText;
	
	                // Make sure the span is in the DOM (it isn't sometimes) before adding this link into the DOM
	                if (watchNavTitleSpan) {
	
	                    // Clear out the span
	                    watchNavTitleSpan.innerHTML = '';
	
	                    // Put the new link in
	                    watchNavTitleSpan.appendChild(newHomeLink);
	                } else {
	
	                    // Clear out the heading
	                    watchNavTitle.innerHTML = '';
	
	                    // Put the new link link
	                    watchNavTitle.appendChild(newHomeLink);
	                } // if span
	            } // if "home"
	        } // navWatchTitleLink()
	
	    }]);
	
	    return NavSection;
	}();
	
	exports.default = NavSection;

/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* This object builds out an overflow menu (when needed) for subnavigation items on section front templates
	*/
	var NavSectionSubnav = function () {
		function NavSectionSubnav() {
			_classCallCheck(this, NavSectionSubnav);
	
			// Navigation wrapper
			var sectionSubnavContainer = document.querySelector('.section-front-navigation');
	
			// if subnav doesn't exist, bail out so we don't throw an error
			if (!sectionSubnavContainer) {
				return;
			}
	
			var sectionSubnavList = sectionSubnavContainer.querySelector('.section-front-subnav');
	
			// Calculated witdhs
			var menuSpaceNeeded = this.getMenuSpaceNeeded(sectionSubnavContainer);
			var menuSpaceAvailable = this.getMenuAvailableSpace(sectionSubnavContainer);
	
			// Nav items
			var sectionNavItems = document.querySelectorAll('.section-front-navigation .section-front-subnav > .menu-item');
			var sectionNavItemsCount = sectionNavItems.length;
	
			// Caching variables
			var obj;
			var j;
	
			// Building out the "More" container for overflow items
			var moreMenuBucket = this.createMoreBucket();
	
			// Put it at the end of the line
			sectionSubnavList.appendChild(moreMenuBucket);
	
			// If the space needed is more than the available space in the UI, we need to build the overflow menu out
			if (menuSpaceNeeded >= menuSpaceAvailable) {
	
				// Show the menu
				this.showElement(document.getElementById('bucket-more-parent'), 'inline-block');
	
				// Loop though all the menu items and when we hit the max width, put them in the overflow
				if (sectionNavItemsCount) {
	
					for (j = 0; j < sectionNavItemsCount; j = j + 1) {
	
						obj = sectionNavItems[j];
	
						// move flagged objects into the overflow container
						if (obj.classList.contains('add-to-overflow')) {
	
							this.addToMoreBucket(obj);
						}
					} // for
				} // if
			} else {
	
				// Hide the menu ( just in case it's showing )
				this.hideElement(document.getElementById('bucket-more-parent'), 'none');
			} // if space is needed
	
			// Events
			// The sub-menu will open on :focus in the CSS, so we don't need extra JS for that, but it's a dead link (#!) so we're just preventing it from firing
			document.getElementById('bucket-more-link').addEventListener('click', function (e) {
				e.preventDefault();
			});
		} // constructor
	
		/**
	 * Hide an element
	 */
	
	
		_createClass(NavSectionSubnav, [{
			key: 'hideElement',
			value: function hideElement(el, displayProperty) {
				el.style.display = displayProperty;
				el.setAttribute('aria-hidden', 'true');
			}
	
			/**
	  * Show an element
	  */
	
		}, {
			key: 'showElement',
			value: function showElement(el, displayProperty) {
				el.style.display = displayProperty;
				el.setAttribute('aria-hidden', 'false');
			}
	
			/**
	  * Add an item into the "more" bucket
	  */
	
		}, {
			key: 'addToMoreBucket',
			value: function addToMoreBucket(el) {
	
				document.getElementById('bucket-more-menu').appendChild(el);
			} // addToMoreBucket()
	
			/**
	  * Create "More" menu item so it can be added to the UI
	  */
	
		}, {
			key: 'createMoreBucket',
			value: function createMoreBucket() {
	
				// Building out the "More" container for overflow items
				var moreMenuBucket = document.createElement('li');
	
				// Set standard WP classes & an ID on the link bucket
				moreMenuBucket.setAttribute('class', 'menu-item menu-item-has-children');
				moreMenuBucket.setAttribute('id', 'bucket-more-parent');
	
				// Hide it by default, because we may not need it yet
				moreMenuBucket.setAttribute('aria-hidden', 'true');
				moreMenuBucket.style.display = 'none';
	
				// Build out the subNav catcher
				var moreMenuCatcher = document.createElement('ul');
				moreMenuCatcher.setAttribute('class', 'sub-menu');
				moreMenuCatcher.setAttribute('id', 'bucket-more-menu');
	
				// Budiling out the link trigger inside the "More" container
				var moreMenuLink = document.createElement('a');
				var moreMenuLinkContent = document.createTextNode('More');
				moreMenuLink.setAttribute('id', 'bucket-more-link');
	
				moreMenuLink.setAttribute('href', '#!');
				moreMenuLink.setAttribute('role', 'button');
	
				// Add content to the link
				moreMenuLink.appendChild(moreMenuLinkContent);
	
				// Putting the link and catcher inside their container
				moreMenuBucket.appendChild(moreMenuLink);
				moreMenuBucket.appendChild(moreMenuCatcher);
	
				return moreMenuBucket;
			} // createMoreBucket()
	
			/**
	  * Return how much space the menu needs based on how many items are in it and the box model calculations
	  */
	
		}, {
			key: 'getMenuSpaceNeeded',
			value: function getMenuSpaceNeeded(nav) {
	
				// Caching and setting some variables
				var navItems = nav.querySelectorAll('.section-front-subnav > .menu-item');
				var navItemsCount = navItems.length;
				var navObjStyle;
				var navItemsSingle;
				var navItemsSingleWidth;
				var navItemsSingleMarginLeft;
				var navItemsSingleMarginRight;
				var navItemsSinglePaddingLeft;
				var navItemsSinglePaddingRight;
				var navItemsSinglePadding;
				var totalWidth;
				var navItemsTotalWidth = 150; // start it at 150 to give us some spacing on the right
				var i;
	
				// Loop through each nav item and get total the width
				if (navItemsCount) {
					for (i = 0; i < navItemsCount; i = i + 1) {
	
						navItemsSingle = navItems[i];
						navObjStyle = navItemsSingle.currentStyle || window.getComputedStyle(navItemsSingle);
						navItemsSingleWidth = navItemsSingle.offsetWidth;
						navItemsSingleMarginLeft = Number(navObjStyle.marginLeft.replace('px', ''));
						navItemsSingleMarginRight = Number(navObjStyle.marginRight.replace('px', '')); // Should be 0, but just in case it changes in the future
						navItemsSinglePaddingLeft = Number(navObjStyle.paddingLeft.replace('px', '')); // Should be 0, but just in case it changes in the future
						navItemsSinglePaddingRight = Number(navObjStyle.paddingRight.replace('px', '')); // Should be 0, but just in case it changes in the future
	
						// Add up all the widths
						totalWidth = navItemsSingleWidth + navItemsSingleMarginLeft + navItemsSingleMarginRight + navItemsSinglePaddingLeft + navItemsSinglePaddingRight;
	
						// Add this width to the overall witdh
						navItemsTotalWidth = totalWidth + navItemsTotalWidth;
	
						if (this.getMenuAvailableSpace(nav) <= navItemsTotalWidth) {
							navItemsSingle.classList.add('add-to-overflow');
						}
					} // for
				} // if
	
				return navItemsTotalWidth;
			} // getMenuItems()
	
			/**
	  * Return the amount of space in nav
	  */
	
		}, {
			key: 'getMenuAvailableSpace',
			value: function getMenuAvailableSpace(nav) {
	
				return nav.offsetWidth;
			} // getMenuItems()
	
	
		}]);
	
		return NavSectionSubnav;
	}(); // NavSectionSubnav
	
	exports.default = NavSectionSubnav;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AccountsService = __webpack_require__(30);
	
	var _AccountsService2 = _interopRequireDefault(_AccountsService);
	
	var _NavSignin = __webpack_require__(31);
	
	var _NavSignin2 = _interopRequireDefault(_NavSignin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavSigninLoader = function () {
		function NavSigninLoader() {
			_classCallCheck(this, NavSigninLoader);
		}
	
		_createClass(NavSigninLoader, [{
			key: "start",
			value: function start(opts) {
				var navSignin = new _NavSignin2.default();
				navSignin.updatelinks();
				_AccountsService2.default.get(function (err, acct) {
					if (err) return console.error(err);
	
					navSignin.toggleUpdate(acct);
					navSignin.attach(acct);
	
					acct.onlogout(function () {
						navSignin.toggleUpdate(acct);
					});
	
					acct.onlogin(function () {
						navSignin.toggleUpdate(acct);
					});
				});
			}
		}, {
			key: "init",
			value: function init() {
				//only start the events if there is global nav; otherwise, it will cause js error
				if (document.getElementById("account-nav-container")) {
					this.start();
				} else {
					return;
				}
			}
		}]);
	
		return NavSigninLoader;
	}();
	
	exports.default = NavSigninLoader;

/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var o = {};
	
	o.getScript = function (url, callback) {
		// Create a new script and setup the basics.
		var script = document.createElement("script"),
		    firstScript = document.getElementsByTagName('script')[0];
	
		script.async = true;
		script.src = url;
	
		// Handle the case where an optional callback was passed in.
		if ("function" === typeof callback) {
			script.onload = function () {
				callback();
	
				// Clear it out to avoid getting called more than once or any memory leaks.
				script.onload = script.onreadystatechange = undefined;
			};
			script.onreadystatechange = function () {
				if ("loaded" === script.readyState || "complete" === script.readyState) {
					script.onload();
				}
			};
		}
	
		// Attach the script tag to the page (before the first script) so the magic can happen.
		firstScript.parentNode.insertBefore(script, firstScript);
	};
	
	o.lazyload = {
		js: function js(urlarr, fn) {
			o.getScript(urlarr[0], function () {
				fn();
			});
		}
	};
	
	o.callcbarr = function (cbarr) {
		var args = [].slice.call(arguments, 1);
		return cbarr.filter(function (cb) {
			cb.apply(1, args);
		});
	};
	
	o.getwisjruncached = function (opts, fn) {
		// some pages ESI include wisRegistration scripts
		// if such is case, do not request
		if ((typeof wisRegistration === "undefined" ? "undefined" : _typeof(wisRegistration)) === 'object') {
			return fn(null, wisRegistration);
		}
	
		o.lazyload.js([opts.url], function () {
			if ((typeof wisRegistration === "undefined" ? "undefined" : _typeof(wisRegistration)) === 'object') {
				fn(null, wisRegistration);
			} else {
				fn('failed to load');
			}
		});
	};
	
	o.getwisjr = function (val, cbarr, isloading) {
		cbarr = [];
		isloading = false;
		return function (opts, fn) {
			cbarr.push(fn);
			if (isloading === false) {
				isloading = val === undefined;
				if (typeof val === 'undefined') {
					o.getwisjruncached(opts, function (err, wisjr) {
						isloading = false;
						cbarr = o.callcbarr(cbarr, err, opts, val = wisjr);
					});
				} else {
					cbarr = o.callcbarr(cbarr, null, opts, val);
				}
			}
		};
	}();
	
	o.get = function (fn) {
		o.getwisjr({
			url: 'http://www.foxsports.com/accounts/Static/Bundle/JS/WIS?v=20150828',
			wisjrfilter: function wisjrfilter(opts, wisjr) {
				var wisjrwrapper = Object.create(wisjr);
	
				wisjrwrapper.getfirstName = function () {
					var firstName = "";
					var wisFirstName = wisjr.getFirstName();
					if (null !== wisFirstName && 'undefined' !== wisFirstName) {
						firstName = wisFirstName.replace(/\+/g, " ");
					}
					return firstName;
				};
				wisjrwrapper.getfirstNameInitial = function () {
					var firstName = wisjr.getFirstName();
					var firstInitial = "";
					if (null !== firstName && 'undefined' !== firstName) {
						firstInitial = firstName.charAt(0);
					}
					return firstInitial;
				};
	
				wisjrwrapper.getlastName = function () {
					var lastName = "";
					var wisLastName = wisjr.getLastName();
					if (null !== wisLastName && 'undefined' !== wisLastName) {
						lastName = wisLastName.replace(/\+/g, " ");
					}
					return lastName;
				};
	
				wisjrwrapper.getlastNameInitial = function () {
					var lastName = wisjr.getLastName();
					var lastInitial = "";
	
					if (null !== lastName && 'undefined' !== lastName) {
						lastInitial = lastName.charAt(0);
					}
					return lastInitial;
				};
	
				wisjrwrapper.onlogin = function (fn) {
					return wisjr.registerForLoginSuccess(fn);
				};
	
				wisjrwrapper.onlogout = function (fn) {
					return wisjr.registerForLogout(fn);
				};
	
				wisjrwrapper.renderlogin = function (fn) {
					return wisjr.startLoginWidget(fn);
				};
	
				wisjrwrapper.isLoggedIn = function () {
					return wisjr.isUserLoggedIn();
				};
	
				wisjrwrapper.isLoggedOut = function () {
					return !this.isLoggedIn();
				};
	
				wisjrwrapper.logout = function () {
					return wisjr.logoutUser();
				};
	
				return wisjrwrapper;
			}
		}, function (err, opts, wisjr) {
			if (err) return fn(err);
	
			if (typeof opts.wisjrfilter === 'function') {
				wisjr = opts.wisjrfilter(opts, wisjr);
			}
	
			fn(err, window.wisjr = wisjr);
		});
	};
	var AccountsService = o;
	
	exports.default = AccountsService;

/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavSignin = function () {
		function NavSignin() {
			_classCallCheck(this, NavSignin);
	
			this.signinContainerId = "SigninContainer";
			this.signinFontIconId = "SigninFontIconContainer";
			this.signoutLink = "userSignOutLink";
			this.greetingContainerId = "greetingContainerId";
			this.greetingNameId = "greetingNameId";
		}
	
		_createClass(NavSignin, [{
			key: "getSigninContainerElem",
			value: function getSigninContainerElem() {
				return document.getElementById(this.signinContainerId);
			}
		}, {
			key: "getSigninFontIconElem",
			value: function getSigninFontIconElem() {
				return document.getElementById(this.signinFontIconId);
			}
		}, {
			key: "getSignoutElem",
			value: function getSignoutElem() {
				return document.getElementById(this.signoutLink);
			}
		}, {
			key: "getGreetingContainer",
			value: function getGreetingContainer() {
				return document.getElementById(this.greetingContainerId);
			}
		}, {
			key: "getGreetingNameElem",
			value: function getGreetingNameElem() {
				return document.getElementById(this.greetingNameId);
			}
		}, {
			key: "doSignin",
			value: function doSignin(acct) {
				acct.renderlogin();
			}
		}, {
			key: "doSignout",
			value: function doSignout(acct) {
				if (acct.isLoggedIn()) {
					acct.logout();
				}
			}
		}, {
			key: "toggleSignedin",
			value: function toggleSignedin() {
				var that = this,
				    signinContainerElem = that.getSigninContainerElem(),
				    signinFontIconElem = that.getSigninFontIconElem();
				if (signinContainerElem && signinFontIconElem) {
					signinFontIconElem.className = "user-icon icon-FS_Icons_signin";
					signinContainerElem.className = "signinContainer site-user-controls logged-in";
				}
			}
		}, {
			key: "toggleSignedout",
			value: function toggleSignedout() {
				var that = this,
				    signinContainerElem = that.getSigninContainerElem(),
				    signinFontIconElem = that.getSigninFontIconElem();
				if (signinContainerElem && signinFontIconElem) {
					signinFontIconElem.className = "user-icon icon-FS_Icons_signout";
					signinContainerElem.className = "signinContainer site-user-controls logged-out";
				}
			}
		}, {
			key: "toggleUpdate",
			value: function toggleUpdate(acct) {
				acct.isLoggedIn() ? this.toggleSignedin() : this.toggleSignedout();
				if (acct.isLoggedIn()) {
					if (acct.getfirstName() !== "" || acct.getlastName() !== "") {
						this.getGreetingContainer().innerHTML = acct.getfirstNameInitial() + acct.getlastNameInitial();
						this.getGreetingNameElem().innerHTML = acct.getfirstName() + " " + acct.getlastName();
					} else {
						this.getGreetingContainer().innerHTML = "FS";
						this.getGreetingNameElem().innerHTML = "Fox Sports Fan";
					}
				} else {
					this.getGreetingContainer().innerHTML = 'Sign In';
				}
			}
		}, {
			key: "updatelinks",
			value: function updatelinks() {
				var logoutlink = document.getElementById('FSDNavAcctLogoutLink'),
				    loginlink = document.getElementById('FSDNavAcctLoginLink'),
				    href = window.location.href;
				if (loginlink) {
					loginlink.href = '/accounts/login?fu=' + encodeURIComponent(href);
				}
			}
		}, {
			key: "buildSignedInLinks",
			value: function buildSignedInLinks(acct) {
				var that = this,
				    host = location.host,
				    userProfileEditLink = document.getElementById("userProfileEditLink"),
				    userAccountEditLink = document.getElementById("userAccountEditLink"),
				    userSignoutLink = that.getSignoutElem();
				userProfileEditLink.href = "http://www.foxsports.com/accounts/settings/account-info";
				userAccountEditLink.href = "http://www.foxsports.com/accounts/settings/favorites";
	
				userSignoutLink.addEventListener('click', function () {
					that.doSignout(acct);
				});
			}
		}, {
			key: "attach",
			value: function attach(acct) {
				var that = this,
				    signinContainerElem = that.getSigninContainerElem(),
				    signinLink = that.getSigninFontIconElem();
				if (signinContainerElem) {
					signinLink.addEventListener('click', function () {
						if (acct.isLoggedIn()) {
							return false;
						} else {
							that.doSignin(acct);
						}
					});
					that.buildSignedInLinks(acct);
				}
			}
		}]);
	
		return NavSignin;
	}();
	
	exports.default = NavSignin;

/***/ },
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TopVideoPlayer = function () {
	    function TopVideoPlayer() {
	        _classCallCheck(this, TopVideoPlayer);
	
	        this.videoLinks = document.querySelectorAll('.top-videos-link');
	
	        this.addClickListeners();
	    } // constructor
	
	    _createClass(TopVideoPlayer, [{
	        key: 'getPlayerVideoTitle',
	        value: function getPlayerVideoTitle() {
	
	            var playerVideoTitleElm = document.querySelector('.titlebar_fg .title');
	            if (playerVideoTitleElm !== null) {
	                return playerVideoTitleElm.innerHTML;
	            }
	            return null;
	        } // getPlayerVideoTitle()
	
	
	    }, {
	        key: 'updateTopVideoPlayer',
	        value: function updateTopVideoPlayer(event) {
	
	            event.preventDefault();
	
	            var elem = event.currentTarget;
	            var releaseUrl = elem.getAttribute('data-release') + elem.getAttribute('data-iu');
	
	            if (fdmPlayer !== 'undefined' && fdmPlayer instanceof Array) {
	
	                fdmPlayer[0].setReleaseCall(releaseUrl);
	            }
	        } // updateTopVideoPlayer()
	
	    }, {
	        key: 'addClickListeners',
	        value: function addClickListeners() {
	
	            var videos = this.videoLinks;
	            var count = videos.length;
	
	            for (var i = 0; i < count; i += 1) {
	                videos[i].addEventListener('click', this.updateTopVideoPlayer.bind(this));
	            }
	        } // addClickListeners()
	
	    }]);
	
	    return TopVideoPlayer;
	}(); // TopVideoPlayer
	
	exports.default = TopVideoPlayer;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// assets/dist/js/section-front.min.js